import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ParamListBase, RouteProp, useIsFocused, useNavigation, useRoute } from '@react-navigation/native';
import { View, KeyboardAvoidingView, useWindowDimensions, ScrollView, Image, Pressable, Platform, Linking, TouchableOpacity } from 'react-native';
import { IconType } from '@rneui/base';
import Popover from "react-native-popover-view/dist/Popover";
import { appColors, appFonts, fontSize } from '../../themes/appTheme';
import CommonHeader from '../../shared/commonComponents/commonHeader';
import { ThemeConsumer } from "@rneui/themed";
import ZenText from 'zen-core-elements/src/elements/zenText/zenText';
import { ZenAvatar, ZenButton, ZenCheckBox, ZenDivider, ZenDropdown, ZenIcon, ZenInput, ZenLoader, ZenToolTip } from 'zen-core-elements';
import { PopoverMode, PopoverPlacement } from 'react-native-popover-view';
import {
    addNotes, dicountType, getOrderDiscount, getOrderedProductModifiers, getShippingDetails, getSingleOrderDetails, InvoiceJson,
    orderInvoice, restoreInventoryLocation, restoreStock, returnRequestOrder, returnRequestproduct, updateDiscount, updateLoyaltyPoints,
    updateOrderedProductModifiers, updateOrderedTracking, updateOrderShipping, updateOrderStatus, updateProductOptionVariants,
    updateRefundAmount, updateReturnProductStatus, getLoyaltyPointsLog,
    getRefundDetails
} from '../../redux/slices/orderDetailSlice';
import { config } from '../../shared/environment';
import { getScreenPermission, useAppDispatch, useAppSelector } from '../../redux/hooks';
import moment from 'moment';
import { propertiesType } from '../../redux/slices/orderSlice';
import ZenToast from 'zen-core-elements/src/elements/ZenToastMessage/zenToast';

import ViewChangesList from './viewChangesList';
import CommonService from '../../shared/services/commonService';
import FormTemplate from './loyalty-refundScreen';
import ReturnReasonScreen from './returnReasonScreen';
import CommonDialogBox from '../../shared/commonComponents/commonDialogBox';
import {
    DiscountDetailsType, handleUpdateOrderStatusType, handleUpdateProductListType, InventoryLocationType,
    locationDetailsType, MergedProductType, ModifierDataListType, orderDetailsType, OrderedProductListType,
    OrderedProductModifierType, ProductModifierType, returnProductsType, ReturnRequestListType, shippingDeliveryType,
    shippingMethodType, ShippingTypeDetailType, userDetailsType
} from './orderDetailModule';
import ReactNativeBlobUtil from 'react-native-blob-util';
import { LineDiscountLabel, orderLineTotal, orderRoundOff, returnDiscountForProduct, summariseOrderDiscounts } from '../../utils/orderDiscountSummary';
import { Buffer } from 'buffer'
import { saveAndPrintDocument } from '../../platform/printer/printer';
import PermissionServices from '../../shared/services/permissionService';
import * as CryptoJs from 'react-native-crypto-js';
import { CustomModal } from '../../shared/commonComponents/customModal';
import { shallowEqual } from 'react-redux';
import { addAdditionalCharge, addAdditionalDiscount, addCartProduct, addCustomer, addTip, clearCart, setReturnRequestData, setReturnRequestWholeOrderData, setSellScreenType } from '../../redux/slices/newSellscreenSlice';
import { number } from 'yup';
import Clipboard from '@react-native-clipboard/clipboard';
import useBackHandler from '../../shared/hooks/useBackHandler';
import { OrderListStyle } from '../../themes/components/order/orderListStyle';
import { ReturnRequestWholeOrder } from '../../redux/types/sellScreenTypes';
import { getOrderSettingsFromAsyncStorage, getReturnWindowDays } from '../../utils/asyncstorageHelper';

export interface RouteType extends ParamListBase {
    orderList: { orderId: number, isPos: boolean };
}

type EncryptAndDecryptOptions = {
    inputString: string;
    key: string;
};

export type orderStatusType = "New" | "Processing" | "Hold" | "Packed" | "Shipped" | "Delivered" | "Returned" | "Cancelled" | "Downloaded" | "Picked up" | "Partially returned"

const OrderDetails = () => {

    const { isLandscape } = useAppSelector((state) => state?.common)
    const navigation = useNavigation()
    const { isWrite: isOrderWrite } = useAppSelector(getScreenPermission("OrdersStack"), shallowEqual)
    const { isWrite: isSellScreenWrite } = useAppSelector(getScreenPermission("SellScreenStack"), shallowEqual)
    const { id: locationId } = useAppSelector((state) => state?.common?.currentLocation)
    useBackHandler()
    const currentUserRole = useAppSelector(state => state?.common?.userDetails?.value?.roleCode)
    const { width, height } = useWindowDimensions()
    const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'

    const isFocus = useIsFocused()

    const dispatch = useAppDispatch()

    const route: RouteProp<RouteType, "orderList"> = useRoute()

    const orderId = route?.params?.orderId
    const isPos = route?.params?.isPos ?? false

    const [orderDetails, setOrderDetails] = useState<orderDetailsType | null>(null)
    // Discount breakdown for POS sell screen orders (per-type totals and per-line labels)
    const discountSummary = useMemo(() => summariseOrderDiscounts(orderDetails), [orderDetails])
    // Not stored: worked out from the exact order total and the rounded payment total
    const roundOffDetails = useMemo(() => orderRoundOff(orderDetails), [orderDetails])

    const [userDetails, setUserDetails] = useState<userDetailsType | null>(null)

    const [locationDetails, setLocationDetails] = useState<locationDetailsType | null>(null)

    const [statusList, setStatusList] = useState<propertiesType[]>([])

    const [selectedStatus, setSelectedStatus] = useState<orderStatusType | string | propertiesType>('')

    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState('')

    const [editAddressVisible, setEditAddressVisible] = useState(false)

    const [orderDiscountList, setOrderDiscountList] = useState<dicountType[]>([])

    const [discountListVisible, setDiscountListVisble] = useState(false)

    const statusProp = useAppSelector((state) => state?.orderSlice?.filterProperties?.value ? state?.orderSlice?.filterProperties?.value : null)

    const [orderNotes, setOrderNotes] = useState<any[]>([])
    const [noteInput, setNoteInput] = useState('')
    const [editingNoteId, setEditingNoteId] = useState<number | null>(null)
    const [showAddNoteField, setShowAddNoteField] = useState(false)

    const [isNewProd, setIsNewProd] = useState(false)

    const [isLoading, setIsLoading] = useState(false)

    const [changeScreenVisbile, setChangeScreenVisible] = useState(false)

    const [productModifier, setProductModifiers] = useState<ProductModifierType | null>(null)

    const [modifiersListOpen, setModifiersListOpen] = useState(false)

    const [trackingVisible, setTrackingVisible] = useState(false)

    const [trackingData, setTrackingData] = useState('')

    const [couponCode, setCouponCode] = useState('')

    const scrollRef = useRef<ScrollView>(null)

    const [refundVisible, setRefundVisible] = useState(false)

    const [loyaltyVisible, setLoyaltyVisible] = useState(false)

    const [formValue, setFormValue] = useState('')

    const [reasonValue, setReasonValue] = useState('')

    const [fullAdjustment, setFullAdjustment] = useState(false)

    const [shippingListVisible, setShippingListVisible] = useState(false)

    const currentUser = useAppSelector((state) => state?.common?.currentUser?.value)

    const [shippingList, setShippingList] = useState<shippingMethodType | null>(null)

    const [shippingData, setShippingData] = useState<ShippingTypeDetailType | null>(null)

    const [ReturnRequestScreen, setReturnRequestScreen] = useState(false)

    const [selectedProduct, setSelectedProduct] = useState<OrderedProductListType | null>(null)

    const [returnStatus, setReturnStatus] = useState<string[] | null>(null)

    const [selectedReturnStatus, setSelectedReturnStatus] = useState('')

    const [returnPopover, setReturnPopover] = useState(false)

    const [restoreLocationVisible, setRestoreLocationVisible] = useState(false)

    const [stockLocation, setStockLocation] = useState<InventoryLocationType[] | null>(null)

    const [stockLocationOpen, setStockLocationOpen] = useState(false)

    const [selectedStockLocation, setSelectedStockLocation] = useState('')

    const [selectedReturnProduct, setSelectedReturnProduct] = useState<ReturnRequestListType | null>(null)

    const [selectedLocationId, setSelectedLocationId] = useState(null)

    const [returnProductDetailsPopOver, setReturnProductDetailsPopOver] = useState(false)

    const [enableRestoreStock, setEnableRestoreStock] = useState(false)

    const [allReturnedStock, setAllReturnedStock] = useState<returnProductsType | []>([])

    const [returnWindow, setReturnWindow] = useState<string | null>(null)

    const [loyaltyHistory, setLoyaltyHistory] = useState<any[]>([])
    const [refundHistory, setRefundHistory] = useState<any[]>([])

    // States for Send Receipt Popup Modal
    const [sendReceiptModalVisible, setSendReceiptModalVisible] = useState(false)
    const [receiptEmail, setReceiptEmail] = useState('')
    const [receiptPhone, setReceiptPhone] = useState('')
    const [emailError, setEmailError] = useState('')
    const [phoneError, setPhoneError] = useState('')
    const [isGiftReceipt, setIsGiftReceipt] = useState(false)

    const handleOpenSendReceiptModal = () => {
        setReceiptEmail(userDetails?.user?.email ?? '');
        setReceiptPhone(userDetails?.user?.phone ?? orderDetails?.phoneNumber ?? '');
        setEmailError('');
        setPhoneError('');
        setIsGiftReceipt(false);
        setSendReceiptModalVisible(true);
    };

    useEffect(() => {
        if (isFocus) {
            dispatch(setSellScreenType("SELL"))
        }
    }, [isFocus])

    const handleSendEmail = () => {
        const email = receiptEmail.trim();
        if (!email) {
            setEmailError('Email is required');
            return;
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) {
            setEmailError('Email is invalid');
            return;
        }
        setEmailError('');
        ZenToast({ type: 'success', message: 'Email Receipt sent successfully' });
        setSendReceiptModalVisible(false);
    };

    const handleSendSMS = () => {
        const phone = receiptPhone.trim();
        if (!phone) {
            setPhoneError('Phone number is required');
            return;
        }
        const phoneRegex = /^[+0-9\s-()]+$/;
        if (!phoneRegex.test(phone)) {
            setPhoneError('Phone number is invalid');
            return;
        }
        setPhoneError('');
        ZenToast({ type: 'success', message: 'Text Receipt sent successfully via SMS' });
        setSendReceiptModalVisible(false);
    };

    const handlePrintGiftReceipt = () => {
        setSendReceiptModalVisible(false);
        ZenToast({ type: 'success', message: 'Generating Gift Receipt (Prices Excluded)...' });
        getOrderInvoice();
    };

    const encryptString = ({ inputString, key }: EncryptAndDecryptOptions) => {
        try {
            const encryptedString = CryptoJs.AES.encrypt(inputString.toString(), key).toString();
            return encryptedString;
        } catch (err) {
            return null;
        }
    };

    // Trigger fetching order details when the screen is focused (`isFocus` is true),
    // an `orderId` exists, and `editAddressVisible` is false.
    // This ensures that the order details are fetched only when the user is not editing the address.

    useEffect(() => {
        if (isFocus && orderId && !editAddressVisible) {
            setIsLoading(true)
            getOrderDetail()
        }
    }, [isFocus, editAddressVisible])

    // Load the return window configured in Order Settings
    useEffect(() => {
        if (isFocus) {
            getOrderSettingsFromAsyncStorage().then((settings) => {
                setReturnWindow(settings.returnWindow)
            }).catch((error) => {
                console.log("Get order settings error", error)
            })
        }
    }, [isFocus])

    // Show a success toast and refresh order details when a new product is added.
    // After handling, reset `isNewProd` to false to prevent repeated execution.
    useEffect(() => {
        if (isNewProd) {
            ZenToast({ type: 'success', message: 'New Product Added Successfully' })
            getOrderDetail()
            setIsNewProd(false)
        }
    }, [isNewProd])


    // * - Fetches order details and updates state variables accordingly.
    // * - Dispatches an action to get order details from the API.
    // * - If no order notes exist, initializes with an empty note.
    // * - Updates order details, including handling return requests and product modifiers.
    // * - Checks if all returned products require stock restoration.
    // * - Updates various state variables like order status, user details, and shipping data.
    // * - Handles errors gracefully to prevent crashes.

    const getOrderDetail = async () => {
        const data =
        {
            isUser: true,
            currentDate: new Date().toString()
        }
        try {
            const singleOrderDetails = await dispatch(getSingleOrderDetails({ storeId: config.storeId, orderId: orderId, data: data, isPos: isPos })).unwrap()
            if (!singleOrderDetails) {
                throw new Error('failed to fetch singleOrderDetails')
            }

            if (singleOrderDetails?.getOrderDetails) {
                let addNotes = singleOrderDetails?.getOrderDetails?.ordersDetails?.orderNotes || []
                if (addNotes?.length) {
                    addNotes = addNotes.map((addAttr) => {
                        return { ...addAttr, isNew: false, focus: false, error: false };
                    });
                }
                if (['Picked up', 'Delivered', 'Returned'].includes(singleOrderDetails?.getOrderDetails?.ordersDetails?.orderStatusName) && singleOrderDetails?.getOrderDetails?.ordersDetails?.returnRequests.length > 0 && singleOrderDetails?.getOrderDetails?.ordersDetails?.orderedProductModifiers.length > 0) {
                    let addModifiersForReturnProducts = { ...handlIsFreeProductExist(singleOrderDetails?.getOrderDetails?.ordersDetails) }

                    // addModifiersForReturnProducts.returnRequests = addModifiersForReturnProducts.returnRequests.map((values) => {
                    //     // Get all matching product modifiers
                    //     const matchingModifiers = addModifiersForReturnProducts.orderedProductModifiers.filter((productMod: OrderedProductModifierType) => {
                    //         return values.productId === productMod.productId && values.variantId === productMod.variantId;
                    //     });

                    //     // Update returnRequestsProductData
                    //     const updatedReturnRequestsProductData = Array.isArray(values.returnRequestsProductData) ? values.returnRequestsProductData.map((add) => ({
                    //         ...add,
                    //         orderModifierList: matchingModifiers.length > 0 ? matchingModifiers : null, // Ensure compatibility
                    //         selected: false,
                    //         // Add or ensure required properties for ReturnRequestsProductData
                    //         name: add.name, // Assuming name exists in add
                    //         productWithOptionPrice: add.productWithOptionPrice,
                    //         taxAmount: add.taxAmount,
                    //         actualPrice: add.actualPrice,
                    //         orderedProductsCustomizeDetails: add.orderedProductsCustomizeDetails,
                    //     })) : [];

                    //     return {
                    //         ...values,
                    //         returnRequestsProductData: updatedReturnRequestsProductData,
                    //     };
                    // });
                    addModifiersForReturnProducts.returnRequests =
                        addModifiersForReturnProducts.returnRequests.map((values) => {

                            // Get matching modifiers
                            const matchingModifiers =
                                addModifiersForReturnProducts.orderedProductModifiers.filter(
                                    (productMod: OrderedProductModifierType) =>
                                        values.productId === productMod.productId &&
                                        values.variantId === productMod.variantId
                                );

                            // Update product data object
                            const updatedReturnRequestsProductData = {
                                ...values.returnRequestsProductData,
                                orderModifierList:
                                    matchingModifiers.length > 0 ? matchingModifiers : null,
                                selected: false,
                            };

                            return {
                                ...values,
                                returnRequestsProductData: updatedReturnRequestsProductData,
                            };
                        });
                    setOrderDetails(addModifiersForReturnProducts)
                }
                else {
                    setOrderDetails(handlIsFreeProductExist(singleOrderDetails?.getOrderDetails?.ordersDetails))
                }
                let filterAllReturned = [...singleOrderDetails?.getOrderDetails?.ordersDetails?.returnRequests]
                let isCheck = filterAllReturned.some((values) => values.status == 'Returned')
                if (isCheck) {
                    let value = await handleCheckAllProductsReturned(singleOrderDetails?.getOrderDetails?.ordersDetails)
                    if (value) {
                        let allStockRestore = filterAllReturned.filter((values) => values.status != 'Declined').some((v) => v.stockRestore)
                        if (allStockRestore) {
                            setEnableRestoreStock(false)
                        }
                        else {
                            setEnableRestoreStock(value ? true : false)
                        }
                    }
                }
                else {
                    setEnableRestoreStock(false)
                }
                setOrderNotes(addNotes)
                if (singleOrderDetails?.getOrderDetails?.ordersDetails?.orderStatusName) {
                    setSelectedStatus(singleOrderDetails?.getOrderDetails?.ordersDetails?.orderStatusName)
                }
                setUserDetails(singleOrderDetails?.getOrderDetails?.userDetails)
                setShippingData(singleOrderDetails?.getOrderDetails?.shippingTypeDetails)
                setLocationDetails(singleOrderDetails?.getOrderDetails?.locationDetails)
                setTrackingData(String(singleOrderDetails?.getOrderDetails?.ordersDetails?.trackingId))
                setSelectedReturnStatus('')
                setIsLoading(false)
                return singleOrderDetails?.getOrderDetails?.ordersDetails
            }
        }
        catch (error) {
            console.log(error);
        }
        getLoyaltyPoints()
    }


    /**
 * Updates the order or payment status and refreshes order details.
 * 
 * @param {'order' | 'payment'} updateEvent - Specifies whether to update the order or payment status.
 * @param {propertiesType | string} selectedStatus - The new status to be applied to the order.
 * @param {boolean} [tracking] - Optional flag to include tracking ID in the update.
 * 
 * - Formats the current date and prepares payloads for order or payment updates.
 * - If `tracking` is enabled, includes the tracking ID in the update.
 * - Dispatches an API call to update the order/payment status.
 * - Refreshes the order details upon successful update.
 * - Displays a success toast message upon completion.
 * - Handles errors gracefully and logs them for debugging.
 */

    const getLoyaltyPoints = async () => {
        try {
            const res = await dispatch(getLoyaltyPointsLog({ storeId: config?.storeId, orderId: orderId, isPos: isPos })).unwrap();

            if (res?.result?.earnDetails) {
                setLoyaltyHistory(res.result.earnDetails);
            }
        } catch (error) {
            console.log("Error fetching loyalty points:", error);
        }
        GetAllRefundDetails()
    }

    const GetAllRefundDetails = async () => {
        try {
            const res = await dispatch(getRefundDetails({ storeId: config?.storeId, orderId: orderId, isPos: isPos })).unwrap();

            if (res?.result?.rows) {
                setRefundHistory(res.result.rows);
            }
        }
        catch (error) {
            console.log("Error fetching refund details:", error);
        }
    }

    const handleUpdateOrderStatus = async (updateEvent: 'order' | 'payment', selectedStatus: propertiesType | string, tracking?: boolean) => {

        if (selectedStatus && userDetails && typeof selectedStatus == 'object') {
            const currentDate = moment(new Date());
            const formattedDate = currentDate.format("MMMM DD, YYYY - hh:mm A"); // Format as required
            let PROPERTIES = statusProp?.propertyValueData.find((i) => i?.code == "ORDER_STATUS")?.propertyValues.find((status) => status?.value == selectedStatus ? selectedStatus : "Paid")?.id
            let orderPayLoad: handleUpdateOrderStatusType =
            {
                "orderStatus": selectedStatus.id ? selectedStatus.id : PROPERTIES ? PROPERTIES : null,
                "orderName": selectedStatus?.value ? selectedStatus?.value : '',
                "orderStatusDate": new Date().toISOString(),
                "event": "statusChange",
                "orderStatusCode": selectedStatus.code ?? String(selectedStatus).toLocaleUpperCase(),
                "todayDate": formattedDate,
                "modifiedAt": currentDate.toISOString(),
                "customizedOrderId": orderDetails?.customizedOrderId ? orderDetails?.customizedOrderId : null,
                "isPreOrder": false,
                "userEmail": userDetails?.user?.email ? userDetails?.user?.email : null,
            }
            let paymentLoad =
            {
                "todayDate": formattedDate,
                "modifiedAt": currentDate.toISOString(),
                "customizedOrderId": orderDetails?.customizedOrderId ? orderDetails?.customizedOrderId : null,
                "isPreOrder": false,
                "userEmail": userDetails?.user?.email ? userDetails?.user?.email : null,
                "status": selectedStatus.value,
            }
            if (tracking) {
                orderPayLoad.trackingId = trackingData
            }
            try {

                const updateOrder = await dispatch(updateOrderStatus({ storeId: config.storeId, orderId: orderId, data: updateEvent == 'order' ? orderPayLoad : paymentLoad, isPos: isPos })).unwrap()
                if (!updateOrder) {
                    console.log('Error in update Status');
                    throw new Error('Error in update Status')
                }
                await getOrderDetail()
                ZenToast({ type: 'success', message: 'Order Fulfillment Status updated Successfully' })

            }
            catch (error) {
                console.log("---Error in update Statu", error);
            }
        }


    }

    /**
     * Determines and updates the possible fulfillment statuses based on the current order status.
     * 
     * @param {orderStatusType | string} status - The current order status.
     * 
     * - Retrieves order status properties from `statusProp`.
     * - Filters possible next statuses based on the current status:
     *   - 'New' → ['Hold', 'Packed', 'Processing']
     *   - 'Processing' → ['Hold', 'Packed']
     *   - 'Hold' → ['Processing']
     *   - 'Packed' → ['Picked up'] (for pickup) or ['Delivered', 'Shipped'] (for delivery)
     *   - 'Shipped' → ['Delivered']
     *   - 'Delivered', 'Picked up', 'Partially returned' → ['Returned']
     * - Updates the `statusList` state with valid next statuses.
     */

    const handleFullfillmentStatus = (status: orderStatusType | string) => {
        let orderType = isPos ? "POS_ORDER_STATUS" : "ORDER_STATUS"
        let statusList: propertiesType[] = []
        let PROPERTIES = statusProp?.propertyValueData.find((i) => i?.code == orderType)
        if (PROPERTIES) {
            if (status == 'New') {
                statusList = PROPERTIES?.propertyValues?.filter((val) => val.value == 'Hold' || val.value == 'Packed' || val.value == 'Processing')
            }
            else if (status == 'Processing') {
                statusList = PROPERTIES?.propertyValues?.filter((val) => val.value == 'Hold' || val.value == 'Packed')
            }
            else if (status == 'Hold') {
                statusList = PROPERTIES?.propertyValues?.filter((val) => val.value == 'Processing')
            }
            else if (status == 'Packed') {
                if (orderDetails?.shippingType == 'PICKUP') {
                    statusList = PROPERTIES?.propertyValues?.filter((val) => val.value == 'Picked up')
                }
                else {
                    statusList = PROPERTIES?.propertyValues?.filter((val) => val.value == 'Delivered' || val.value == 'Shipped')
                }
            }
            else if (status == 'Shipped') {
                statusList = PROPERTIES?.propertyValues?.filter((val) => val.value == 'Delivered' || val.value == 'Shipped')
            }
            else if (status == 'Delivered' || status == 'Picked up' || status == 'Partially returned') {
                statusList = PROPERTIES?.propertyValues?.filter((val) => val.value == 'Returned')

            }
            setStatusList(statusList)
        }

    }

    /**
 * Returns the corresponding color for a given order status.
 * 
 * @param {orderStatusType | string} status - The order status to determine the color for.
 * @returns {string} - The color code associated with the given status.
 * 
 * - Maps order statuses to predefined colors from `appColors`:
 */

    const handleStatusColor = (status: orderStatusType | string) => {
        let color = ''
        switch (status) {
            case 'New':
                color = appColors.mayGreen
                break;
            case 'Processing':
                color = appColors.lightYellow
                break;
            case 'Hold':
                color = appColors.lightDark
                break;
            case 'Packed': case 'Partially returned':
                color = appColors.lightDarkBlue
                break;
            case 'Delivered': case 'Downloaded':
                color = appColors.green
                break
            case 'Returned':
                color = appColors.red
                break
            case 'Shipped':
                color = appColors.wildBlue
                break
            case 'Picked up':
                color = appColors.wildPink
                break
            case 'Cancelled':
                color = appColors.red
                break
        }
        return color
    }

    /**
 * Reorders the `orderedProductsList` to move free products to the end of the list.
 * 
 * @param {orderDetailsType} orderDetails - The order details containing product information.
 * @returns {orderDetailsType} - The updated order details with free products moved to the end.
 * 
 * - Checks if any product in `orderedProductsList` is marked as `isFreeProduct`.
 * - Separates free and purchased products.
 * - Combines them with purchased products first and free products last.
 * - Returns a modified `orderDetails` object with the updated product list.
 */

    const handlIsFreeProductExist = (orderDetails: orderDetailsType) => {
        if (Array.isArray(orderDetails?.orderedProductsList) && orderDetails.orderedProductsList.some((value) => value.isFreeProduct)) {
            let freeproducts = orderDetails?.orderedProductsList.filter((getvalue) => getvalue.isFreeProduct);
            let pruchasedProducts = orderDetails?.orderedProductsList.filter((getPurchase) => !getPurchase.isFreeProduct);
            // Combine free and purchased products into a single array
            let combineProducts = [...pruchasedProducts, ...freeproducts];

            return { ...orderDetails, orderedProductsList: combineProducts };
        }
        else {
            return orderDetails
        }

    }

    /**
 * Updates the order discount by applying a promo code.
 * 
 * @async
 * @function handleUpdateOrderDiscount
 * @returns {Promise<void>}
 * 
 * - Constructs the discount update payload with order and store details.
 * - Dispatches `updateDiscount` action to update the discount.
 * - Shows a warning toast if the update returns a message.
 * - Shows a success toast when the discount is applied successfully.
 * - Resets the discount input fields and fetches updated order details.
 * - Logs an error if the update fails.
 */

    const handleUpdateOrderDiscount = async () => {
        try {
            const data =
            {
                "OrderedProductId": null,
                "productId": null,
                "variantId": null,
                "combinationName": null,
                "orderId": orderId,
                "storeId": config.storeId,
                "orderedProductsList": null,
                "currency": currencySymbol,
                "quantity": 0,
                "event": null,
                "promoCode": couponCode,
                "customerId": orderDetails?.customerId ?? 0,
                "customizedOrderId": orderDetails?.customizedOrderId ? orderDetails?.customizedOrderId : '',
                "modifiedAt": new Date().toISOString(),
                "userEmail": userDetails ? userDetails?.user?.email ?? '' : '',
                "isInclusiveTax": orderDetails?.isInclusiveTax ? orderDetails?.isInclusiveTax : false,
                "nameJson": null,
                "variantNameJson": null,
                "currentDate": new Date().toString()
            }
            const isUpdateDiscount = await dispatch(updateDiscount({ storeId: config.storeId, orderId: orderId, data: data, isPos: isPos })).unwrap()
            if (!isUpdateDiscount) {
                throw new Error('error in updateOrderDiscount')
            }
            if (isUpdateDiscount?.updateOrder?.message) {
                ZenToast({ type: 'warning', message: isUpdateDiscount?.updateOrder?.message })
            }
            ZenToast({ type: 'success', message: 'Offer applied successfully' })
            setDiscountListVisble(false)
            setCouponCode('')
            getOrderDetail()
        }
        catch (error) {
            console.log("error in update dicount", error);
        }

    }

    /**
 * Handles adding or deleting order notes.
 * 
 * @async
 * @function handleOrderNotes
 * @param {Object} noteValue - The note details.
 * @param {string} noteValue.notes - The note text.
 * @param {boolean} noteValue.isNew - Whether the note is newly created.
 * @param {number} noteValue.id - The note ID (if updating).
 * @param {'Delete'} [event] - If provided, the function will delete the note instead of adding/updating it.
 * @returns {Promise<void>}
 * 
 * - Constructs the payload for adding or deleting a note.
 * - Dispatches `addNotes` action with the relevant data.
 * - Displays an info toast if there's no change.
 * - Displays a success toast if the note is updated successfully.
 * - Refreshes the order details after update.
 * - Logs an error if the operation fails.
 */

    const handleOrderNotes = async (noteValue: { notes: string, isNew: boolean, id: number }, event?: 'Delete') => {
        try {
            const data =
            {
                "orderNotesValue": noteValue?.notes,
                "orderNotesPrivacy": 'Public',
                "id": noteValue?.isNew ? null : noteValue?.id,
                "orderId": String(orderId),
            }

            let deleteData =
            {
                "id": noteValue?.id,
                "orderId": String(orderId),
                isDeleted: true
            }
            let isAdd = await dispatch(addNotes({ storeId: config.storeId, data: event ? deleteData : data, isPos: isPos })).unwrap()
            if (!isAdd) {
                throw new Error('error in handleNotes')
            }
            if (isAdd?.orderNotes?.duplicateEntry) {
                ZenToast({ type: 'info', message: 'you have no changes to save' })
            }
            else {
                ZenToast({ type: 'success', message: 'staff notes updated successfully' })
                getOrderDetail()
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    const handleAddNote = async () => {
        if (noteInput.trim() === '') {
            ZenToast({ type: 'info', message: 'Please enter a note.' });
            return;
        }
        await handleOrderNotes({ notes: noteInput.trim(), isNew: true, id: 0 });
        setNoteInput('');
    }

    /**
 * Generates an avatar string based on the initials of the given names.
 * 
 * @param {string} first - The first name.
 * @param {string} second - The second name.
 * @returns {string} - A string representing the initials, e.g., "A B" or "AB".
 * 
 * - If both `first` and `second` names are provided, returns the first letters of both, separated by a space.
 * - If only the `first` name is provided, returns the first two letters of the `first` name.
 * - Returns an empty string if neither name is provided.
 */

    const handleAvatar = (first: string, second: string) => {
        let store = ''
        if (first && second) {
            store = first.slice(0, 1) + " " + second.slice(0, 1)
        }
        else if (first) {
            store = first.slice(0, 1) + first.slice(1, 2)
        }
        return store
    }

    /**
 * Fetches the order discount details based on the current order and customer information.
 * 
 * @async
 * @returns {Promise<void>} - No return value. Updates the state with the fetched discount data.
 * 
 * The function:
 * - Calculates the total quantity of ordered products.
 * - Prepares the data for the API request, including the total amount and product quantity.
 * - Fetches the available discounts for the order using `getOrderDiscount`.
 * - Maps through the order-level discounts to determine the selected coupon and updates the UI state accordingly.
 */

    const getOrderDiscountDetail = async () => {
        try {
            const totalQuantity = orderDetails?.orderedProductsList.reduce((acc: number, current) => {
                return acc + Number(current.quantity); // Convert quantity to a number
            }, 0);
            const data =
            {
                "products": null,
                "storeId": config.storeId,
                "amount": {
                    "subTotal": Number(orderDetails?.totalAmount),
                    "productQty": totalQuantity ? totalQuantity : null
                },
                "customerId": orderDetails?.customerId ? orderDetails?.customerId : 0,
                "currentDate": new Date().toISOString()
            }

            const couponList = await dispatch(getOrderDiscount({ storeId: config.storeId, data: data })).unwrap()
            if (!couponList) {
                throw new Error('error in coupon List')
            }

            if (couponList?.discounts.orderLevelDiscounts) {
                let format = [...couponList?.discounts.orderLevelDiscounts]
                format = format.map((prevs) => {
                    let prev = { ...prevs }
                    if (prev.promoCode == handleDiscountDetails(orderDetails?.discountDetails ? orderDetails?.discountDetails : [])) {
                        setCouponCode(prev.promoCode)
                        prev.selected = true
                    }
                    else {
                        prev.selected = false
                    }
                    return prev
                })
                setOrderDiscountList(format)
                if (format.length > 0) {
                    setDiscountListVisble(true)
                }
                else {
                    ZenToast({ type: 'info', message: 'No Coupon Code found' })
                }
            }

        }
        catch (err) {
            console.log(err);
        }

    }

    /**
 * Updates the product list when the quantity is changed or a product is removed from the order.
 * 
 * @async
 * @param {MergedProductType} selectedProduct - The product whose quantity or removal is being updated.
 * @param {'plus' | 'minus' | 'remove'} event - The type of event that determines the action (increase quantity, decrease quantity, or remove product).
 * @returns {Promise<void>} - No return value. Updates the state and makes the API call to update the product list.
 * 
 * The function:
 * - Creates the data object with the updated product details.
 * - Adjusts the quantity and event type based on the action ('plus', 'minus', or 'remove').
 * - Dispatches the `updateProductOptionVariants` action to update the product in the order.
 * - Displays a success toast and updates the order details.
 */

    const handleUpdateProductList = async (selectedProduct: MergedProductType, event: 'plus' | 'minus' | 'remove') => {
        try {
            if (selectedProduct.orderProductId) {
                let data: handleUpdateProductListType =
                {
                    "OrderedProductId": selectedProduct?.orderProductId ?? null,
                    "productId": selectedProduct?.productId ?? null,
                    "variantId": selectedProduct?.variantId ?? null,
                    "combinationName": null,
                    "orderId": orderId,
                    "storeId": config.storeId,
                    "orderedProductsList": null,
                    "currency": currencySymbol,
                    "quantity": event == 'minus' ? Number(selectedProduct?.quantity) - 1 == 0 ? 0 : Number(selectedProduct?.quantity) : Number(selectedProduct?.quantity),
                    "event": {
                        "productId": selectedProduct?.productId ?? null,
                        "productIndex": selectedProduct?.index,
                        "isAdded": 1,
                        "variantId": selectedProduct?.variantId,
                        "fbtId": null
                    },
                    "promoCode": null,
                    "customerId": orderDetails?.customerId ? orderDetails?.customerId : null,
                    "customizedOrderId": orderDetails?.customizedOrderId ? orderDetails?.customizedOrderId : null,
                    "modifiedAt": new Date().toISOString(),
                    "userEmail": userDetails ? userDetails?.user?.email : null,
                    "isInclusiveTax": false,
                    "nameJson": selectedProduct?.nameJson ?? null,
                    "variantNameJson": selectedProduct?.variantNameJson ?? null,
                    "currentDate": new Date().toString()
                }
                if (event == 'minus' || event == 'remove') {
                    if (Number(selectedProduct?.quantity) - 1 == 0 || event == 'remove') {
                        data.event.isDeleted = data.event.isAdded
                        delete data.event.isAdded
                    }
                    else {
                        data.event.isMinus = data.event.isAdded
                        delete data.event.isAdded
                    }
                }
                const isUpdate = await dispatch(updateProductOptionVariants({ storeId: config.storeId, orderId: orderId, data: data, isPos: isPos })).unwrap()
                if (!isUpdate) {
                    throw new Error('Error in handleUpdateProductList')
                }
                ZenToast({ type: 'success', message: isUpdate?.updateOrder?.message ?? 'Product Quantity Updated Successfully ' })
                getOrderDetail()
            }

        }
        catch (error) {
            console.log("Error in handleUpdateProductList");
        }

    }

    /**
 * Calculates the total count of ordered products that are not marked as deleted.
 * 
 * @param {OrderedProductListType[]} allProducts - The list of all ordered products to be filtered and counted.
 * @returns {number} - The count of products that are not deleted.
 * 
 * The function:
 * - Filters out the products that are marked as deleted (`isDeleted` property).
 * - Returns the length of the filtered list, representing the count of active products.
 */


    const handleProductCount = (allProducts: OrderedProductListType[]) => {
        if (allProducts) {
            let count = allProducts.filter((i) => !i.isDeleted).length
            return count
        }
        else {
            return 0
        }
    }

    /**
 * Fetches and sets product modifiers for the given product and variant.
 * 
 * @param {number} productId - The ID of the product to retrieve modifiers for.
 * @param {number} variantId - The ID of the product variant to retrieve modifiers for.
 * @param {MergedProductType} selectedProduct - The selected product object containing product details.
 * @returns {Promise<void>} - A promise that resolves when the product modifiers are successfully fetched and processed.
 * 
 * The function:
 * - Dispatches an action to fetch product modifiers for a given product and variant.
 * - Maps through the fetched modifiers and compares them to existing modifiers in the order details.
 * - Updates the product modifiers state and opens the modifiers list if modifiers are available.
 * - Displays a toast message if no modifiers are available.
 */


    const getProductModifiers = async (productId: number, variantId: number, selectedProduct: MergedProductType) => {
        try {
            const isProductModifiers = await dispatch(getOrderedProductModifiers({ storeId: config.storeId, productId: productId, variantId: variantId })).unwrap()
            if (!isProductModifiers) {
                throw new Error(' error in getProductModifiers')
            }
            if (isProductModifiers?.result?.productModifiers.length) {
                let addFlag = isProductModifiers?.result
                addFlag.productId = productId
                addFlag.variantId = variantId
                addFlag.combinationName = selectedProduct?.combinationName ?? null
                addFlag.orderProductId = selectedProduct?.orderProductId ? selectedProduct?.orderProductId : 0
                addFlag.productModifiers = addFlag.productModifiers.map((prev) => {
                    const isAdding = { ...prev };
                    let existModifiers = orderDetails?.orderedProductModifiers ?? []
                    existModifiers = existModifiers.filter((valueKey) => valueKey.productId == productId && valueKey.variantId == variantId)
                    return isAdding;
                });
                setProductModifiers(addFlag)

                setModifiersListOpen(true)
            }
            else {
                ZenToast({ message: 'Modifiers are unavailable for this product', type: 'info' })
            }
        }
        catch (error) {
            console.log("error in getProductmodifiers", error);
        }

    }

    /**
 * Processes the product modifier mappings and returns a list of selected modifiers.
 *
 * @param {ProductModifierType | null} modifierMappings - The modifier mappings object containing modifier set data.
 * @returns {Array | undefined} - An array of formatted modifier objects with selected options, or undefined if no modifiers are selected.
 *
 * The function:
 * - Maps through the `modifierSetMappings` to identify selected modifiers.
 * - Returns an array of selected modifier objects containing the modifier ID, modifier set ID, option value, and price.
 * - If no modifiers are selected, returns undefined.
 */

    const selectedModifiersHelper = (modifierMappings: ProductModifierType | null) => {
        if (modifierMappings?.productModifiers?.length) {
            let FormatModifier = modifierMappings?.productModifiers?.flatMap((values) =>
                values?.modifierData?.modifierSetMappings.map((mappings) => {
                    if (mappings.isSelected) {
                        return {
                            "modifierId": mappings.modifier.id,
                            "modifierSetId": mappings.modifierSetId,
                            "optionValue": mappings?.modifier?.optionValue || "",
                            "price": mappings?.modifier?.price || ""
                        };
                    }
                }).filter(Boolean) // Remove undefined values from map
            );

            return FormatModifier

        }
    }

    /**
 * Handles the update of product modifiers for a selected product in the order.
 *
 * @param {MergedProductType | null} selectedProduct - The selected product whose modifiers are being updated.
 * @param {ModifierDataListType | null} filterModifier - Optional parameter for filtered modifier data.
 * 
 * The function:
 * - Constructs a `data` object with relevant product and modifier information.
 * - Calls the API to update the product modifiers with the given data.
 * - On success, displays a success message and refreshes the order details.
 */


    const handleUpdateProductModifiers = async (selectedProduct?: MergedProductType | null, filterModifier?: ModifierDataListType | null) => {
        try {
            const data = {
                "productId": productModifier?.productId ?? selectedProduct?.productId,
                "variantId": productModifier?.variantId ?? selectedProduct?.variantId,
                "combinationName": productModifier?.combinationName ?? selectedProduct?.combinationName ?? null,
                "storeId": config.storeId,
                "event": "Modifier update",
                "selectedModifiers": selectedModifiersHelper(productModifier) ?? filterModifier ?? [],
                "currency": "INR",
                "orderId": orderId,
                "OrderedProductId": productModifier?.orderProductId ?? selectedProduct?.orderProductId,
                "userEmail": userDetails ? userDetails?.user?.email : null,
                "currentDate": new Date().toISOString()
            }
            const isModifierUpdated = await dispatch(updateOrderedProductModifiers({ storeId: config.storeId, orderId: orderId, data: data })).unwrap()
            if (!isModifierUpdated) {
                throw new Error('error in handleUpdateProductModifiers')
            }
            ZenToast({ type: 'success', message: isModifierUpdated.updateOrder.message ?? 'Product Updated Succesfully' })
            getOrderDetail()

        }
        catch (error) {

        }

    }

    const handleDiscountDetails = (discountMappings: DiscountDetailsType) => {
        if (discountMappings?.length) {
            let manualDiscount = discountMappings.filter((val) => val.appliedDiscountType == 'MANUAL').map((value) => value.discount.promoCode)
            return manualDiscount ?? ''
        }
        else {
            return ''
        }
    }

    /**
 * Updates the tracking details for the current order.
 * This function:
 * 1. Checks if the necessary orderId and trackingData are provided.
 * 2. Sends a request to update the tracking details for the order.
 * 3. If successful, it updates the order details and shows a success message.
 * 4. If there is an error at any point, it logs the error and shows an error message to the user.
 */

    const handleUpdateTrackDetails = async () => {
        try {
            let data =
            {
                id: String(orderId),
                trackingId: trackingData
            }
            const isTrackUpdate = await dispatch(updateOrderedTracking({ storeId: config.storeId, orderId: orderId, data: data })).unwrap()

            if (!isTrackUpdate) {
                throw new Error('Error in handleUpdateTrackDetails')
            }
            getOrderDetail()
            ZenToast({ message: 'Tracking Details updated succesfully', type: 'success' })
        }
        catch (error) {

        }

    }

    /**
 * Handles the process of updating refund or loyalty points adjustments.
 * This function can process either a refund or loyalty points update, depending on the event type.
 * 
 * 1. If the event is 'Refund':
 *    - Encrypts the refund details and sends a request to update the refund amount.
 *    - On success, shows a success message and hides the refund form.
 * 2. If the event is 'Loyalty':
 *    - Sends a request to update the customer's loyalty points balance.
 *    - On success, shows a success message and hides the loyalty points form.
 * 
 * In both cases, the order details are re-fetched and appropriate messages are shown to the user.
 */

    const handleUpdateRefundAmount = async (event: 'Refund' | 'Loyalty') => {
        try {
            if (event === 'Refund') {
                const data = {
                    orders: {
                        amountPaid: encryptString({ inputString: orderDetails?.amountPaid ?? '', key: config.secretKey }),
                        customerId: orderDetails?.customerId ?? '',
                        phoneNumber: orderDetails?.phoneNumber ?? '',
                    },
                    refund: {
                        orderId: String(orderId),
                        refundAmount: encryptString({ inputString: formValue, key: config.secretKey }),
                        refundReason: reasonValue,
                        refundType: 'Cash Refund',
                        customizedOrderId: orderDetails?.customizedOrderId,
                    },
                };
                const isUpdateRefund = await dispatch(updateRefundAmount({ storeId: config.storeId, data: data })).unwrap();

                if (!isUpdateRefund) {
                    throw new Error('Error in updating refund amount');
                }
                ZenToast({ type: 'success', message: 'Refund has been processed successfully.' })
                setRefundVisible(false)
                setFullAdjustment(false)

            }
            else if (event === 'Loyalty') {
                const data = {
                    adjustmentType: 'Decrement',
                    amount: formValue,
                    description: reasonValue,
                    isOrders: true,
                    isearnAdjustment: true,
                    orderId: String(orderId),
                };

                const isUpdateLoyalty = await dispatch(
                    updateLoyaltyPoints({ storeId: config.storeId, customerId: orderDetails?.customerId ? orderDetails?.customerId : 0, data })
                ).unwrap();

                if (!isUpdateLoyalty) {
                    throw new Error('Error in updating loyalty points');
                }
                ZenToast({ type: 'success', message: 'Loyalty earn points updated successfully.' })

                setLoyaltyVisible(false)
                setFullAdjustment(false)

            }
            await getOrderDetail()
        }
        catch (error: any) {
            console.error(`Error in handleUpdate${event}:`, error?.message || error);
        }
    }

    /**
 * Fetches available shipping methods for the current order.
 * This function prepares a data object with necessary information like storeId, locationId, orderId, and currency,
 * then dispatches an action to retrieve the shipping details for the order.
 * 
 * - If the order has more than one shipping method available, it updates the shipping data accordingly.
 * - If a shipping method already exists, it marks that method as "selected."
 * - If no shipping methods are available, it shows a toast message to inform the user.
 * 
 * The fetched shipping methods are stored and displayed if available.
 */

    const getShippingMethods = async () => {
        try {
            const data =
            {
                storeId: config.storeId,
                isUser: true,
                locationId: locationDetails ? locationDetails?.id : 0,
                orderId: orderId,
                currency: currentUser?.store.currencyData.currencySymbol,
                subscription: undefined
            }
            const isAllShippingMethods = await dispatch(getShippingDetails({ storeId: config.storeId, orderId: orderId, data: JSON.parse(JSON.stringify(data)) })).unwrap()

            if (!isAllShippingMethods) {
                throw new Error('error in getShippingmethods')
            }
            if (isAllShippingMethods?.shipping?.delivery.length > 1) {

                if (shippingData) {
                    const isExistShipping = {
                        ...isAllShippingMethods?.shipping,
                        updateOrder: {
                            ...isAllShippingMethods?.shipping?.updateOrder,
                            delivery: isAllShippingMethods?.shipping?.updateOrder?.delivery?.map((findValue) => ({
                                ...findValue,
                                isExist: findValue?.id === shippingData?.id,
                            })) || [], // Ensure delivery is always an array
                            cartProductList: isAllShippingMethods?.shipping?.updateOrder?.cartProductList || [], // Ensure cartProductList is always an array
                        },
                    };

                    setShippingList(isExistShipping);
                    // setShippingList(isExistShipping);
                }
                else {
                    setShippingList(isAllShippingMethods?.shipping)
                }
                setShippingListVisible(true)
            }
            else {
                ZenToast({ type: 'info', message: 'Delivery methods are currently not available for this order.' })
            }

        }
        catch (error) {
            console.log("error in getShippingmethods----", error);

        }
    }

    /**
 * Updates the shipping details for the current order.
 * 
 * @param {Object} deliveryData - The selected shipping method and its details.
 * @param {number} orderId - The ID of the order to update.
 * @param {Object} orderDetails - The current details of the order (including service charges, pickup address, etc.).
 * @param {Object} config - Configuration containing store ID and secret key.
 * @param {Function} dispatch - Function to dispatch actions.
 * @param {Function} getOrderDetail - Function to re-fetch the order details.
 * @param {Function} setShippingListVisible - Function to toggle visibility of the shipping options list.
 * 
 * @returns {Promise<void>} - A promise that resolves when the shipping update is complete.
 */
    const handleUpdateOrderShipping = async (deliveryData: shippingDeliveryType) => {
        try {
            const data = {
                "shippingRate": deliveryData?.amount,
                "newShipping": true,
                "shippingMethodId": deliveryData?.id,
                "calculationJson": {
                    "delivery": deliveryData,
                    "serviceCharge": orderDetails?.calculationJson?.serviceCharge,
                    "additionalCharge": orderDetails?.calculationJson?.additionalCharge,
                    "tipAmount": orderDetails?.calculationJson?.tipAmount,
                    "codDetails": orderDetails?.calculationJson?.codDetails
                },
                "pickupAddress": orderDetails?.pickupAddress,
                "expectedDate": orderDetails?.expectedDate,
                "orderId": String(orderId),
                "modifiedAt": new Date().toISOString()
            }

            const isUpdateShipping = await dispatch(updateOrderShipping({ storeId: config.storeId, data: data })).unwrap()
            if (!isUpdateShipping) {
                throw new Error('error in UpdateShipping')
            }
            await getOrderDetail()
            setShippingListVisible(false)

        }
        catch (error) {
            console.log("error in handleUpdateShipping", error);
        }

    }

    const findOrderStatus = (orderData: orderDetailsType) => {
        const totalOrderedProductQty = orderData?.orderedProductsList?.reduce((accumulator, currentValue) => accumulator + Number(currentValue?.quantity), 0)
        const totalReturnedProductQty = orderData?.returnRequests?.reduce((accumulator, currentValue) => accumulator + Number(currentValue?.returnQty), 0)
        console.log(totalOrderedProductQty, totalReturnedProductQty, "totalOrderedProductQty, totalReturnedProductQty");

        if (totalOrderedProductQty !== totalReturnedProductQty) {
            return {
                "value": "Partially returned",
                "code": "PARTIALLY_RETURNED",
                "id": 1402,

            }
        }
        console.log(orderData?.returnRequestStatus);

        return orderData?.returnRequestStatus?.find(item => item?.code === "RETURNED")
    }
    console.log(findOrderStatus(orderDetails), "=-============================");

    const handleReturnRequestOrderForSellScreen = (actionValue: string, isReturnWholeOrder: boolean, returnProductQty?: string, currentReturnedProductData?: ReturnRequestListType, returnWholeOrderData?: ReturnRequestListType[], orderData: orderDetailsType) => {
        console.log(actionValue, JSON.stringify(returnWholeOrderData, undefined, 4));

        // A returned unit gives back its own line discount when the order recorded one (sell screen orders)
        const orderedLine = (orderProductId?: number) => orderDetails?.orderedProductsList?.find((line) => line?.orderProductId === orderProductId)
        const returnDiscount = (returned?: ReturnRequestListType) => returnDiscountForProduct({ product: orderedLine(returned?.orderProductId), returnQty: Number(returned?.returnQty), unitPrice: Number(returned?.productPrice), orderDiscount: orderDetails?.discountAmount, orderSubTotal: orderDetails?.subTotal })
        const discountAmoutForSpecificProduct = returnDiscount(currentReturnedProductData)
        dispatch(clearCart())
        console.log(discountAmoutForSpecificProduct, "discountAmoutForSpecificProduct");
        let sum = 0
        const returnRequestWholeOrder: ReturnRequestWholeOrder[] = []
        if (isReturnWholeOrder) {
            returnWholeOrderData?.map(item => {
                const discountAmoutForSpecificOrder = returnDiscount(item)
                sum += discountAmoutForSpecificOrder
                console.log(discountAmoutForSpecificOrder, "discountAmoutForSpecificOrder");
                returnRequestWholeOrder.push({
                    "variantSkuId": item?.variantId,
                    "combinationName": item?.combinationName,
                    "productPrice": Number(item?.productPrice),
                    "quantity": item?.returnQty,
                    "productId": item?.productId,
                    "locationId": orderDetails?.locationId!,
                    "orderProductId": item?.orderProductId,
                    "productName": item?.returnRequestsProductData ? item?.returnRequestsProductData?.name : '',
                    "imageUrl": item?.featuredImage!,
                    "reason": item?.reason! ?? orderDetails?.returnActionData[0]?.reason!,
                    "comments": item?.comments ? item?.comments : null,
                    "selectedModifiers": item?.returnRequestsProductData ? item?.returnRequestsProductData?.orderModifierList ?? null : null,
                })
                dispatch(addCartProduct({
                    product: {
                        name: item?.name,
                        price: Number(item?.productPrice),
                        quantity: Number(item?.returnQty) * -1,
                        variantId: item?.variantId,
                        productId: item?.productId,
                        weightCount: item?.weightCount,
                        stock: Number(item?.stock),
                        finalPrice: Number(item?.productPrice) * Number(item?.returnQty) * -1,
                        sku: item?.sku,
                        upc: item?.upc,
                        variantName: item?.variantName ?? "",
                        discount: discountAmoutForSpecificOrder,
                        autoDiscount: 0,
                        automaticDiscount: [],
                        tax: Number(item?.returnRequestsProductData?.inclusiveTaxPrice),
                        isVariants: item?.isVariants ?? false,
                        wholeSalePrice: 0,
                        weight: item?.weight,
                        weightUnitId: null,
                        weightUnit: null,
                        featuredImage: item?.featuredImage || null,
                        multiLocationVariantStocksId: 0,
                        variantSkuId: item?.variantId,
                    },
                    locationId: orderDetails?.locationId
                }))
            })
            dispatch(setReturnRequestWholeOrderData(returnRequestWholeOrder))
            console.log(sum, "sum");

            dispatch(addAdditionalDiscount({
                discount: {
                    discount: Number(sum),
                    discountAmount: Number(sum),
                    type: "FIXED"
                },
                locationId: orderDetails?.locationId!
            }))
        } else {
            dispatch(addCartProduct({
                product: {
                    name: currentReturnedProductData?.name!,
                    price: Number(currentReturnedProductData?.productPrice),
                    quantity: Number(returnProductQty) * -1,
                    variantId: currentReturnedProductData?.variantId!,
                    productId: currentReturnedProductData?.productId!,
                    weightCount: currentReturnedProductData?.weightCount!,
                    stock: Number(currentReturnedProductData?.stock),
                    finalPrice: Number(currentReturnedProductData?.productPrice) * Number(returnProductQty) * -1,
                    sku: currentReturnedProductData?.sku!,
                    upc: currentReturnedProductData?.upc!,
                    variantName: currentReturnedProductData?.variantName ?? "",
                    discount: discountAmoutForSpecificProduct,
                    autoDiscount: 0,
                    automaticDiscount: [],
                    tax: Number(currentReturnedProductData?.inclusiveTaxPrice),
                    isVariants: currentReturnedProductData?.isVariants ?? false,
                    wholeSalePrice: 0,
                    weight: currentReturnedProductData?.weight!,
                    weightUnitId: null,
                    weightUnit: null,
                    featuredImage: currentReturnedProductData?.featuredImage || null,
                    multiLocationVariantStocksId: 0,
                    variantSkuId: currentReturnedProductData?.variantId!,
                },
                locationId: orderDetails?.locationId!
            }))
            dispatch(addAdditionalDiscount({
                discount: {
                    discount: discountAmoutForSpecificProduct,
                    discountAmount: discountAmoutForSpecificProduct,
                    type: "FIXED"
                },
                locationId: orderDetails?.locationId!
            }))
        }
        dispatch(setSellScreenType(actionValue === "Refund" ? "RETURN" : "REPLACEMENT"))
        dispatch(addAdditionalCharge({
            charge: {
                amount: 0,
                type: "FIXED",
                charge: 0
            },
            locationId: orderDetails?.locationId!
        }))

        let customer = {
            id: userDetails?.user?.id!,
            countryCode: userDetails?.user?.countryCode!,
            loyaltyPoints: 0,
            onAccountDetails: { limit: 0, balance: 0 },
            name: userDetails?.user?.firstName + (userDetails?.user?.lastName ? (" " + userDetails?.user?.lastName) : ""),
            phone: userDetails?.user?.phone?.toString() || "",
            address: null,
            customerId: orderDetails?.customerId!,
            dateOfBirth: "",
            email: userDetails?.user?.email!,
            firstName: userDetails?.user?.firstName ?? "",
            lastName: userDetails?.user?.lastName ?? "",
            isApproved: userDetails?.isApproved ?? false,
            isSmsVerified: userDetails?.user?.isUserVerified ?? false,
            isSocialUser: false,
            isWholesale: userDetails?.isWholesale,
            isUserVerified: userDetails?.user?.isUserVerified ?? false,
            role: userDetails?.user?.role!,
            roleId: userDetails?.user?.roleId!,
            shopappUser: null,
            storeId: config?.storeId
        }
        dispatch(addCustomer({
            customerDetails: {
                details: customer, locationId: config?.storeId
            }
        }))
        dispatch(addTip({ tip: 0, locationId }))
        const orderStatusData = findOrderStatus(orderData)

        dispatch(setReturnRequestData({
            "orderId": orderId,
            "productId": currentReturnedProductData?.productId!,
            "productPrice": Number(currentReturnedProductData?.productPrice),
            "orderProductId": currentReturnedProductData?.orderProductId!,
            "combinationName": currentReturnedProductData?.combinationName ? currentReturnedProductData?.combinationName : '',
            "variantId": currentReturnedProductData?.variantId ? currentReturnedProductData?.variantId : null,
            "productName": currentReturnedProductData?.returnRequestsProductData ? currentReturnedProductData?.returnRequestsProductData?.name : '',
            "quantity": currentReturnedProductData?.returnQty!,
            "imageUrl": currentReturnedProductData?.featuredImage!,
            "reason": currentReturnedProductData?.reason! ?? orderDetails?.returnActionData[0]?.reason!,
            "comments": currentReturnedProductData?.comments ? currentReturnedProductData?.comments : null,
            "selectedModifiers": currentReturnedProductData?.returnRequestsProductData ? currentReturnedProductData?.returnRequestsProductData?.orderModifierList ?? null : null,
            "locationId": orderDetails?.locationId!,
            "customizedOrderId": orderDetails?.customizedOrderId,
            "languageCode": orderDetails?.languageCode!,
            id: isReturnWholeOrder ? orderDetails?.returnActionData[0]?.id : currentReturnedProductData?.id,
            orderName: orderStatusData?.value,
            orderStatus: orderStatusData?.id,
            orderStatusCode: orderStatusData?.code,
            action: actionValue,
            userName: userDetails?.user?.firstName ? userDetails?.user?.firstName! + userDetails?.user?.lastName ? userDetails?.user?.lastName! : '' : '',
            isReturnWholeOrder,
        }))
        navigation.navigate("SellScreenStack", { screen: "NewSellScreen" })
    }

    /**
 * Handles the return request for either the entire order or a specific product.
 * 
 * @param {Object} requestValue - The details for the return request.
 * @param {string} requestValue.otherReasonValue - Any additional reason for the return.
 * @param {string} requestValue.returnComment - Comments regarding the return.
 * @param {string} requestValue.reasonValue - The reason for the return (e.g., damaged, unwanted).
 * @param {string} requestValue.actionValue - The action to be taken (e.g., refund, exchange).
 * @param {number} requestValue.productQuantity - The quantity of the product being returned.
 * @param {boolean} requestValue.isOrder - Flag indicating if the return is for the entire order or just a product.
 * 
 * @returns {Promise<void>} - A promise that resolves when the return request is successfully processed.
 */

    const updateReturnRequest = async (requestValue: { otherReasonValue: string, returnComment: string, reasonValue: string, actionValue: string, productQuantity: number, isOrder: boolean }) => {
        try {
            if (requestValue.isOrder && userDetails) {
                const data = {
                    "todayDate": moment(new Date()).format('MMMM D, YYYY - h:mm A'),
                    "statusChange": "orderLevel",
                    "action": requestValue.actionValue,
                    "comments": requestValue.returnComment ? requestValue.returnComment : null,
                    "otherReason": requestValue?.otherReasonValue ? requestValue?.otherReasonValue : null,
                    "reason": requestValue.reasonValue ? requestValue.reasonValue : null,
                    "userName": userDetails ? userDetails?.user?.firstName ?? '' + userDetails?.user?.lastName ? userDetails?.user?.lastName : '' : '',
                    "email": userDetails?.user?.email,
                    "locationId": selectedProduct?.locationId,
                    "customerId": orderDetails?.customerId,
                    "customizedOrderId": orderDetails?.customizedOrderId,
                    "languageCode": orderDetails?.languageCode
                }
                await dispatch(returnRequestOrder({ storeId: config.storeId, orderId: orderId, data: data })).unwrap().then(async (returnRequestOrderRes) => {

                    ZenToast({ type: 'success', message: 'Return request for order sent successfully.' })
                    setReturnRequestScreen(false)
                    setIsLoading(true)
                    await getOrderDetail().then((orderData) => {
                        // const returnWholeOrderData = returnRequestOrderRes?.returnRequestOrderResponse?.map(returnedItems => orderData?.returnRequests?.filter((orderedReturnData) => returnedItems?.id === orderedReturnData?.id))
                        const productData = orderData?.orderedProductsList?.reduce(
                            (result, orderProduct) => {
                                const returnedItem =
                                    returnRequestOrderRes?.returnRequestOrderResponse?.filter(returnData => returnData?.status !== "Returned")
                                        ?.find(
                                            returnedItem => returnedItem?.variantId === orderProduct?.variantId
                                        );

                                if (returnedItem) {
                                    result.push({
                                        ...orderProduct,
                                        returnQty: returnedItem.returnQty,
                                        id: returnedItem?.id,
                                        customizedOrderId: orderDetails?.customizedOrderId,
                                        reason: returnedItem?.reason
                                    });
                                }
                                return result;
                            },
                            []
                        );

                        handleReturnRequestOrderForSellScreen(requestValue.actionValue, true, undefined, undefined, productData, orderData)
                    })
                })
                    .catch((err) => {
                        throw new Error("Error in ReturnOrder");
                    })
            }
            else {
                const data =
                {
                    "todayDate": moment(new Date()).format('MMMM D, YYYY - h:mm A'),
                    "statusChange": "productLevel",
                    "userName": userDetails ? userDetails?.user?.firstName ?? '' + userDetails?.user?.lastName ? userDetails?.user?.lastName : '' : '',
                    "email": userDetails ? userDetails?.user?.email : '',
                    "imageUrl": selectedProduct?.featuredImage ?? null,
                    "productName": selectedProduct?.name,
                    "locationId": selectedProduct?.locationId,
                    "quantity": selectedProduct?.quantity,
                    "returnQuantity": requestValue.productQuantity,
                    "reason": requestValue?.reasonValue,
                    "action": requestValue?.actionValue,
                    "otherReason": requestValue.otherReasonValue ? requestValue.otherReasonValue : null,
                    "comments": requestValue?.returnComment ? requestValue?.returnComment : null,
                    "productId": selectedProduct?.productId,
                    "variantId": selectedProduct?.variantId ?? null,
                    "combinationName": selectedProduct?.combinationName ?? null,
                    "customerId": orderDetails?.customerId,
                    "orderProductId": selectedProduct?.orderProductId,
                    "customizedOrderId": orderDetails?.customizedOrderId,
                    "nameJson": selectedProduct?.nameJson ?? null,
                    "variantNameJson": selectedProduct?.variantNameJson ?? null,
                    "languageCode": orderDetails?.languageCode
                }
                await dispatch(returnRequestproduct({ storeId: config.storeId, orderId: orderId, productId: selectedProduct?.productId ?? 0, data: data })).unwrap()
                    .then(async (returnRequestProductRes: any) => {
                        const returnRequestId = returnRequestProductRes?.returnRequestProductResponse?.id
                        setIsLoading(true)
                        await getOrderDetail().then((orderData) => {
                            const currentReturnedProductData = orderData?.returnRequests?.find(returnedProducts => returnedProducts?.id === returnRequestId)
                            ZenToast({ type: 'success', message: 'Return request for product sent successfully.' })

                            setReturnRequestScreen(false)
                            const productData = orderData?.orderedProductsList?.reduce(
                                (result, orderProduct) => {
                                    const returnedItem = orderProduct?.variantId === currentReturnedProductData?.variantId

                                    if (returnedItem) {
                                        result = {
                                            ...orderProduct,
                                            returnQty: currentReturnedProductData?.returnQty,
                                            id: currentReturnedProductData?.id,
                                            customizedOrderId: orderDetails?.customizedOrderId,
                                            reason: currentReturnedProductData?.reason
                                        };
                                    }

                                    return result;
                                },
                                {}
                            );
                            handleReturnRequestOrderForSellScreen(requestValue.actionValue, false, String(requestValue?.productQuantity), productData, undefined, orderData)
                        })


                    }).catch((err) => {
                        throw new Error('Error in updateReturnRequest')
                    })
            }


        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * Checks whether an order has remaining unreturned items based on the active return requests.
     *
     * @returns {boolean} `true` if the order still has items that can be returned (not fully returned), `false` if the order is fully returned.
     */
    const hasReturnableItems = () => {
        const totalOrderedProductQty = orderDetails?.orderedProductsList?.reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue?.quantity || 0),
            0
        ) || 0;

        const totalReturnedProductQty = (orderDetails?.returnRequests || [])
            .filter((value) => value?.status?.toLowerCase() !== 'declined')
            .reduce(
                (accumulator, currentValue) => accumulator + Number(currentValue?.returnQty || 0),
                0
            );

        return totalOrderedProductQty > totalReturnedProductQty;
    }
    /**
     * Checks whether an order has any returnable items based on the active return requests.
     *
     * @returns {boolean} `true` if the order has at least one item that can be returned, `false` otherwise.
     */
    const isAllProductsAreReturnable = () => {
        return orderDetails?.orderedProductsList?.every(value => value?.isReturnable)
    }

    /**
     * Returns the last date on which a return can be requested, based on the return window in Order Settings.
     * POS orders are fulfilled at the time of sale, so the window starts from the order's created date.
     *
     * @returns {moment.Moment | null} The return deadline, or `null` when returns are unlimited.
     */
    const getReturnDeadline = () => {
        const returnWindowDays = getReturnWindowDays(returnWindow)
        if (returnWindowDays === null || !orderDetails?.createdAt) {
            return null
        }
        return moment(orderDetails?.createdAt).add(returnWindowDays, 'days').endOf('day')
    }

    const returnDeadline = getReturnDeadline()
    const isWithinReturnWindow = !returnDeadline || moment().isSameOrBefore(returnDeadline)

    const hasReturnableItemsForContinue = () => {
        const totalOrderedProductQty = orderDetails?.orderedProductsList?.reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue?.quantity || 0),
            0
        ) || 0;

        const totalReturnedProductQty = (orderDetails?.returnRequests || [])
            .filter((value) => value?.status?.toLowerCase() !== 'declined')
            .reduce(
                (accumulator, currentValue) => accumulator + Number(currentValue?.returnQty || 0),
                0
            );

        return totalOrderedProductQty > totalReturnedProductQty;
    }

    /**
     * Checks if a specific product in an order still has returnable quantity remaining
     * based on active return requests.
     * 
     * @param {MergedProductType} orderProduct - The product to check for return status.
     * @returns {boolean} `true` if the product has remaining quantity that can still be returned (not fully returned),
     *                    `false` if fully returned or invalid.
     */
    const hasReturnableProductQty = (orderProduct: MergedProductType) => {
        if (orderProduct) {
            let totalCount = 0;
            const isReturnable = (orderDetails?.returnRequests || []).filter(
                (value) =>
                    (value?.orderProductId && orderProduct?.orderProductId
                        ? value.orderProductId === orderProduct.orderProductId
                        : (value.productId == orderProduct.productId && value.variantId == orderProduct.variantId)) &&
                    value?.status?.toLowerCase() !== 'declined'
            );

            if (isReturnable) {
                totalCount = isReturnable.length ? isReturnable.reduce((acc: number, qty) => acc + Number(qty.returnQty || 0), 0) : 0;
                return totalCount < Number(orderProduct.quantity || 0);
            }
        }
        return false;
    }

    const handleRequestIcon = (values: 'Approved' | 'Returned' | 'Declined' | string) => {
        let iconName = ''
        if (values == 'Approved') {
            iconName = 'chevron-down'
        }
        else if (values == 'Returned') {
            iconName = 'refresh'
        }
        else if (values == 'Declined') {
            iconName = 'alert-circle'
        }
        return iconName
    }

    /**
 * Returns the color associated with the given return request status.
 * 
 * @param {('Approved' | 'Returned' | 'Declined' | string)} values - The status of the return request.
 * 
 * @returns {string} - The color associated with the status.
 */


    const handleReturnRequestColor = (values: 'Approved' | 'Returned' | 'Declined' | string) => {
        let color = ''
        if (values == 'Approved') {
            color = appColors.green
        }
        else if (values == 'Returned') {
            color = appColors.lightDarkBlue
        }
        else {
            color = appColors.red
        }
        return color

    }

    /**
 * Retrieves and formats the inventory locations for the provided products,
 * then updates the UI with the location data.
 * 
 * @param {Array} values - List of products with their details (productName, variantId, productId).
 * @returns {Promise<void>} - A promise that resolves when the inventory locations are successfully fetched and displayed.
 */

    const getRestoreInventoryLocation = async (values: { productName: string, variantId: number, productId: number }[]) => {
        try {
            if (values) {
                let data = null
                data = values
                if (data?.length) {
                    const allInventoryLocation = await dispatch(restoreInventoryLocation({ storeId: config.storeId, data: { "productInfo": JSON.stringify(data) } })).unwrap()
                    if (!allInventoryLocation) {
                        throw new Error('error in restoreInventoryLocation')
                    }
                    let formatedLocation = allInventoryLocation?.locationList?.location
                    if (formatedLocation) {
                        formatedLocation = formatedLocation?.map((values) => {
                            return {
                                ...values,
                                label: values?.locationName,
                                value: values?.locationName
                            }
                        })
                        setStockLocation(formatedLocation)
                        setRestoreLocationVisible(true)
                    }
                    else {
                        ZenToast({ type: 'info', message: 'please add location first' })
                    }

                }

            }

        }
        catch (error) {
            console.log("error in restoreInventoryLocation", error);

        }

    }

    /**
 * Updates the status of a return request and sends it to the backend.
 * 
 * @returns {Promise<void>} - A promise that resolves when the return request status is updated successfully.
 */

    const handleUpdateReturnRequestStatus = async () => {
        try {
            let data =
            {
                "todayDate": moment(new Date).format('MMMM DD, YYYY - hh:mm A'),
                "status": selectedReturnStatus,
                "statusChange": "statusChange",
                "email": userDetails ? userDetails?.user?.email : '',
                "orderId": String(orderId),
                "productId": selectedReturnProduct?.productId,
                "orderProductId": selectedReturnProduct?.orderProductId,
                "combinationName": selectedReturnProduct?.combinationName ? selectedReturnProduct?.combinationName : '',
                "variantId": selectedReturnProduct?.variantId ? selectedReturnProduct?.variantId : null,
                "productName": selectedReturnProduct?.returnRequestsProductData ? selectedReturnProduct?.returnRequestsProductData?.name : '',
                "userName": userDetails ? userDetails?.user?.firstName ?? '' + userDetails?.user?.lastName ? userDetails?.user?.lastName : '' : '',
                "customerId": orderDetails?.customerId,
                "quantity": selectedReturnProduct?.returnQty,
                "imageUrl": selectedReturnProduct?.featuredImage,
                "action": selectedReturnProduct?.action,
                "reason": selectedReturnProduct?.reason,
                "comments": selectedReturnProduct?.comments ? selectedReturnProduct?.comments : null,
                "selectedModifiers": selectedReturnProduct?.returnRequestsProductData ? selectedReturnProduct?.returnRequestsProductData?.orderModifierList ?? null : null,
                "customizedOrderId": selectedReturnProduct?.customizedOrderId,
                "languageCode": orderDetails?.languageCode
            }
            const updateReturnRequest = await dispatch(updateReturnProductStatus({ storeId: config.storeId, orderId: orderId, returnId: selectedReturnProduct?.id ? selectedReturnProduct?.id : 0, data: data })).unwrap()

            if (!updateReturnRequest) {
                throw new Error('error in updateReturnRequest')
            }

            ZenToast({ type: 'success', message: 'Return status updates successfully' })
        }
        catch (error) {
            console.log("error in handleUpdateReturnRequestStatus", error);

        }

    }

    const enableRestorePopover = () => {
        setTimeout(() => {
            setReturnPopover(true)
        }, 1200);
    }
    /**
     * Updates the stock status by restoring either all returned products or a specific product.
     * 
     * @param {boolean} [isAllProduct=false] - Flag indicating if all returned products are being restored, or just a specific product.
     * @returns {Promise<void>} - A promise that resolves when stock is restored successfully.
     */

    const updateRestoreStock = async (isAllProduct?: boolean) => {
        try {

            let data = {}
            if (isAllProduct) {
                data = {
                    "returnedStock": allReturnedStock,
                    "modifiedAt": new Date().toISOString(),
                    "customizedOrderId": orderDetails?.customizedOrderId,
                    "isPreOrder": false,
                    "userEmail": userDetails ? userDetails?.user?.email ? userDetails?.user?.email : null : null
                }
            }

            else {
                data = {
                    "stockRestoredReturnProducts": true,
                    "variantId": [
                        {
                            "variantSkuId": selectedReturnProduct?.variantId,
                            "productId": selectedReturnProduct?.productId,
                            "quantity": selectedReturnProduct?.returnQty,
                            "locationId": selectedLocationId
                        }
                    ],
                    "returnRequestId": selectedReturnProduct?.id,
                    "productLevelRestoreStock": true
                }

            }

            const isUpdatedStock = await dispatch(restoreStock({ storeId: config.storeId, orderId: orderId, data: data, AllProducts: isAllProduct ? true : false })).unwrap()

            if (!isUpdatedStock) {
                throw new Error('error in updateRestoreStock')
            }
            ZenToast({ type: 'success', message: 'Stock restored successfully' })
            await getOrderDetail()
        }
        catch (error) {
            console.log("error in updateRestoreStock", error);
        }

    }

    const handleUpdateReturnProductQuantity = (product: any) => {
        if (product?.length) {
            let addwithQuantity = []
            let duplicatesId = []
            for (let trackA = 0; trackA < product.length; trackA++) {
                for (let trackB = trackA + 1; trackB < product.length; trackB++) {
                    if (product[trackA].productId == product[trackB].productId && product[trackA].status == 'Returned' && product[trackB].status == 'Returned' && !product[trackA].includes(duplicatesId)) {
                        duplicatesId.push(String(product[trackA].productId))
                        let item = product[trackA]
                        let qty = 0
                        qty += product[trackB].returnQty
                        item.returnQty = item.returnQty + qty
                        addwithQuantity.push(item)
                    }
                }
            }
        }
    }
    /**
     * Checks if all ordered products in the given `productData` have been fully returned.
     * 
     * @param {orderDetailsType} productData - The order details, including ordered products and return requests.
     * @returns {boolean} - Returns `true` if all products have been fully returned, otherwise `false`.
     */

    const handleCheckAllProductsReturned = async (productData: orderDetailsType) => {
        if (productData) {
            let orderedProducts = Array.isArray(productData?.orderedProductsList) ? [...productData?.orderedProductsList] : []
            let returnProducts = Array.isArray(productData?.returnRequests) ? [...productData?.returnRequests] : []
            let isExist = []
            let isFullyRetuned = false

            for (let isProduct = 0; isProduct < orderedProducts.length; isProduct++) {
                let quantity = 0
                let isReturnProduct = {}
                for (let isReturn = 0; isReturn < returnProducts.length; isReturn++) {
                    if (orderedProducts[isProduct].productId == returnProducts[isReturn].productId && orderedProducts[isProduct].variantId == returnProducts[isReturn].variantId && orderedProducts[isProduct].orderProductId == returnProducts[isReturn].orderProductId && !returnProducts[isReturn]["isVisited"] && returnProducts[isReturn].status == 'Returned') {
                        // returnProducts[isReturn]["isVisited"] = true
                        quantity += returnProducts[isReturn].returnQty
                        isReturnProduct = returnProducts[isReturn]
                    }
                    else {

                    }
                }

                if (Number(quantity) == Number(orderedProducts[isProduct].quantity)) {
                    isExist.push({ variantSkuId: orderedProducts[isProduct]?.variantId, productId: orderedProducts[isProduct].productId, variantId: orderedProducts[isProduct]?.variantId, productName: orderedProducts[isProduct]?.name, quantity: Number(orderedProducts[isProduct]?.quantity) })
                    isFullyRetuned = true
                    continue
                }
                else {
                    isExist = []
                    isFullyRetuned = false
                    break
                }
            }
            setAllReturnedStock(isExist)
            return isFullyRetuned
        }
    }

    const getOrderInvoice = async () => {
        let data =
        {
            id: String(orderId),
            orderedDate: moment(orderDetails?.createdAt).format("D/M/YY"),
            isStoreAdmin: true,
            value: false
        }

        await dispatch(orderInvoice({ data: data })).unwrap().then((res) => {
            if (!res?.invoice) {
                throw new Error('Error in order Invoice')
            }

            let isCreated = downloadPdf(res)
            if (!isCreated) {
                ZenToast({ type: 'info', message: 'permission denied' })
            }

        })
            .catch((error) => {
                console.log('Error in order Invoice', error)
            })

    }

    const downloadPdf = async (bufferRes: InvoiceJson) => {
        if (Platform.OS == 'android') {
            const hasPermission = PermissionServices.storegeAccessPermission()

            hasPermission.then(async (response) => {
                if (response) {

                    await helpDownloadFile(bufferRes)
                }
            })
                .catch((error) => {
                    ZenToast({ type: 'info', message: error })
                    console.log("error in the log", error);
                })
        }
        else {
            await helpDownloadFile(bufferRes)
        }
    }

    const helpDownloadFile = async (bufferRes: InvoiceJson) => {
        try {

            if (bufferRes) {

                const bufferData = bufferRes?.invoice?.content?.data

                const base64Data = Buffer.from(bufferData).toString('base64');

                const file = bufferRes.invoice?.fileName

                /**
                 * Writing to the device and printing is platform specific:
                 * Android/iOS write to Downloads/Documents and hand the file to
                 * react-native-print; the browser downloads the PDF and opens it
                 * in the built-in viewer. Both live behind the same call, in
                 * src/platform/printer/printer{,.web}.ts.
                 */
                ZenToast({ type: 'success', message: `${file} saved successfully` })

                // Not awaited, matching the previous behaviour: the print
                // dialog must not block the rest of the screen.
                saveAndPrintDocument({ base64: base64Data, fileName: file })
                    .catch((error) => console.log("error while printing invoice-->", error))
            }
        }
        catch (error) {
            console.log("error in downloading pdf-->", error);
        }
    }

    const goToTelePad = (phoneNumber: string) => {
        Linking.openURL(`tel:${phoneNumber}`);
    }

    const goToEmail = (email: string) => {
        Linking.openURL(`mailto:${email}`);
    }

    const returnDataChange = (data: { returnRequestsProductData: { selected: boolean } }) => {
        if (data != undefined) {
            let flag = data.returnRequestsProductData?.selected
            return flag
        }
        else {
            return false
        }
    }

    const IconTemplate = ({ name, type, content1, iconColor, content2, gap }: { name?: string, type: IconType, content1: string, content2: string, iconColor: string, gap?: number }) => {
        return (
            <View style={[{ flexDirection: 'row', justifyContent: 'center', marginVertical: 15 }]}>
                {name && <View style={{ width: 45, height: 45, backgroundColor: appColors.primary, borderRadius: 50, alignItems: 'center', justifyContent: 'center' }}>
                    <ZenIcon name={name} type={type} size={25} color={appColors.light} />
                </View>}
                <View style={{ marginHorizontal: 15 }}>
                    <ZenText content={content1} size={fontSize.largerFontSize} style={{ textTransform: 'capitalize', color: appColors.dark }} />
                    <ZenText content={content2} size={fontSize.smallFontSize} style={{ textTransform: 'capitalize', color: appColors.lightDark }} />
                </View>
            </View>
        )
    }

    const TextTemplate = ({ name, amount, isNormal, color }: { name: string, amount: string | number, isNormal?: boolean, color?: string }) => {
        return (
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginVertical: 5 }}>
                <ZenText content={name} bold style={{ textTransform: 'capitalize' }} color={isNormal ? color : appColors.lightDark} />
                <ZenText content={/* isNormal ?  */`${CommonService.currencyStandard(currencySymbol, String(amount ? amount : 0))}`/*  : amount */} style={{ textTransform: 'capitalize' }} />
            </View>
        )
    }

    const ListTemplate = ({ orderedProductsList, returnData }: { orderedProductsList: MergedProductType[], returnData?: ReturnRequestListType }) => {

        return (

            Array.isArray(orderedProductsList) ?
                orderedProductsList.map((product, index: number) =>
                (
                    !product?.isDeleted ?
                        <View
                            key={returnData ? `${returnData.id}_${product.id}` : `index_${index}`}
                            style={{
                                width: '95%',
                                alignSelf: 'center',
                                backgroundColor: appColors.light,
                                borderRadius: 12,
                                padding: 12,
                                marginBottom: 12,
                                shadowColor: "#000",
                                shadowOffset: { width: 0, height: 2 },
                                shadowOpacity: 0.1,
                                shadowRadius: 4,
                                elevation: 3,
                                borderWidth: 1,
                                borderColor: appColors.coolGray
                            }}>
                            <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                <Image
                                    source={product?.featuredImage ? { uri: config.AWSImageUrl + product?.featuredImage } : returnData?.featuredImage ? { uri: config.AWSImageUrl + returnData?.featuredImage } : require('../../assets/pos.png')}
                                    style={{ width: width >= 600 ? 80 : 60, height: width >= 600 ? 80 : 60, borderRadius: 8 }}
                                    resizeMode='contain'
                                />

                                <View style={{ flex: 1, marginLeft: 12 }}>
                                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <View style={{ flex: 1, marginRight: 8 }}>
                                            <ZenText content={`${product?.name} ${product?.combinationName}`} bold size={fontSize.mediumFontSize} color={appColors.dark} />
                                            <ZenText content={returnData ? `Quantity: ${returnData?.returnQty}` : `Quantity: ${product?.quantity}`} size={fontSize.smallFontSize} color={appColors.lightDark} />
                                            {!!product?.instruction && (
                                                <ZenText content={`Note: ${product.instruction}`} size={fontSize.smallFontSize} color={appColors.lightDark} style={{ marginTop: 4, fontStyle: 'italic' }} />
                                            )}
                                        </View>

                                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                            {returnData && (
                                                <ZenIcon
                                                    name='eye'
                                                    type='material-community'
                                                    size={22}
                                                    color={appColors.primary}
                                                    style={{ marginRight: 8 }}
                                                    onPress={() => {
                                                        setSelectedReturnProduct(returnData)
                                                        setReturnProductDetailsPopOver(true)
                                                    }}
                                                />
                                            )}

                                            {((selectedStatus == 'Delivered' || selectedStatus == 'Picked up' || selectedStatus == 'Partially returned') && !returnData) && (!orderDetails?.isDigitalOrder) && hasReturnableProductQty(product) && (product?.isReturnable || currentUserRole === "STOREADMIN") && isOrderWrite && isWithinReturnWindow && (
                                                <ZenIcon
                                                    name='restart'
                                                    type='material-community'
                                                    color={appColors.red}
                                                    size={22}
                                                    onPress={() => {
                                                        if (orderDetails?.returnRequests && orderDetails?.returnRequests.length > 0) {
                                                            let returnProducts = [...orderDetails?.returnRequests]
                                                            let editQuantity = { ...product }
                                                            returnProducts.forEach((values) => {
                                                                if (values.productId == editQuantity.productId && values.status != 'Declined') {
                                                                    let isExistQuantity = Number(editQuantity?.quantity ? editQuantity?.quantity : 0) - Number(values?.returnQty ? values?.returnQty : 0)
                                                                    editQuantity.quantity = String(isExistQuantity)
                                                                }
                                                            })
                                                            setSelectedProduct(editQuantity as OrderedProductListType)
                                                            setReturnRequestScreen(true)
                                                        } else {
                                                            setSelectedProduct(product as OrderedProductListType)
                                                            setReturnRequestScreen(true)
                                                        }
                                                    }}
                                                />
                                            )}
                                        </View>
                                    </View>

                                    <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginTop: 8, alignItems: 'flex-end' }}>
                                        <View style={{ flex: 1, flexDirection: 'row', flexWrap: 'wrap' }}>
                                            <View style={{ marginRight: 15 }}>
                                                <ZenText content="Price" size={fontSize.smallFontSize} color={appColors.lightDark} />
                                                <ZenText content={`${CommonService.currencyStandard(currencySymbol, String((returnData ? product?.productWithOptionPrice : product?.productPrice) ?? 0))}`} bold size={fontSize.smallFontSize} />
                                            </View>
                                            {product?.addons && (
                                                <View style={{ marginRight: 15 }}>
                                                    <ZenText content="Add-on" size={fontSize.smallFontSize} color={appColors.lightDark} />
                                                    <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(product?.modifierPrice ?? 0))}`} bold size={fontSize.smallFontSize} />
                                                </View>
                                            )}
                                            {product?.taxAmount && (
                                                <View style={{ marginRight: 15 }}>
                                                    <ZenText content="Tax" size={fontSize.smallFontSize} color={appColors.lightDark} />
                                                    <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(product?.taxAmount ?? 0))}`} bold size={fontSize.smallFontSize} />
                                                </View>
                                            )}
                                            {!returnData && !product?.isFreeProduct && Number(product?.appliedDiscountValue) > 0 && (
                                                <View style={{ marginRight: 15 }}>
                                                    <ZenText content="Discount" size={fontSize.smallFontSize} color={appColors.lightDark} />
                                                    <ZenText content={`-${CommonService.currencyStandard(currencySymbol, String(product?.appliedDiscountValue ?? 0))}`} bold size={fontSize.smallFontSize} color={appColors.green} />
                                                </View>
                                            )}
                                            {!returnData && (discountSummary.linesByOrderedProductId[product?.orderProductId ?? -1] ?? []).length > 0 && (
                                                <View style={{ width: '100%', flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
                                                    {(discountSummary.linesByOrderedProductId[product?.orderProductId ?? -1] ?? []).map((label: LineDiscountLabel) => (
                                                        <View key={`${label.discountId}-${label.type}`} style={{ backgroundColor: appColors.green + '15', paddingHorizontal: 8, paddingVertical: 3, borderRadius: 6 }}>
                                                            <ZenText content={label.type === 'PAY_X_GET_FREE' ? `Free with ${label.title}` : `${label.title} · -${CommonService.currencyStandard(currencySymbol, String(label.amount))}`} size={fontSize.badgeFontSize} color={appColors.green} />
                                                        </View>
                                                    ))}
                                                </View>
                                            )}
                                        </View>

                                        {returnData ? (
                                            <View style={{ alignSelf: 'flex-end' }}>
                                                <ZenToolTip
                                                    isVisible={returnDataChange(returnData) ? true : false}
                                                    popoverStyle={{ elevation: 10, paddingHorizontal: 5 }}
                                                    backgroundColor={appColors.light}
                                                    onRequestClose={() => {
                                                        setOrderDetails((prev) => {
                                                            if (!prev) return prev;
                                                            return {
                                                                ...prev,
                                                                returnRequests: prev.returnRequests?.map((val) => ({
                                                                    ...val,
                                                                    returnRequestsProductData: {
                                                                        ...val.returnRequestsProductData,
                                                                        selected: false,
                                                                    }
                                                                })),
                                                            };
                                                        });
                                                    }}
                                                    content={
                                                        <View>
                                                            {returnStatus?.map((v, k) => (
                                                                <Pressable key={k} style={{ paddingHorizontal: width >= 600 ? 15 : 5, paddingVertical: width >= 600 ? 7 : 3, justifyContent: 'center', alignItems: 'center', width: width >= 600 ? 130 : 90, height: width >= 600 ? 50 : 25 }} onPress={() => {
                                                                    let reqStatus = ['Declined', 'Returned']
                                                                    setReturnStatus(reqStatus)
                                                                    setOrderDetails((prev) => {
                                                                        if (!prev) return prev
                                                                        return {
                                                                            ...prev,
                                                                            returnRequests: prev?.returnRequests.map((val) => ({
                                                                                ...val,
                                                                                returnRequestsProductData: { ...val.returnRequestsProductData, selected: false }
                                                                            })),
                                                                        };
                                                                    });
                                                                    setSelectedReturnStatus(v)
                                                                    setSelectedReturnProduct(returnData)
                                                                    setTimeout(() => { setReturnPopover(true) }, 1000)
                                                                }}>
                                                                    <ZenText content={v} color={appColors.green} size={width >= 600 ? fontSize.mediumFontSize : fontSize.smallFontSize} />
                                                                </Pressable>
                                                            ))}
                                                        </View>
                                                    }
                                                    height={width >= 600 ? 80 : 70}
                                                    width={width >= 600 ? 140 : 90}
                                                    placement={PopoverPlacement.BOTTOM}
                                                    popover={
                                                        <Pressable
                                                            onPress={() => {
                                                                if (returnData?.status == 'Approved') {
                                                                    let reqStatus = ['Returned', 'Declined']
                                                                    setReturnStatus(reqStatus)
                                                                    setOrderDetails((prev) => {
                                                                        if (!prev) return prev
                                                                        return {
                                                                            ...prev,
                                                                            returnRequests: prev?.returnRequests.map((val) => ({
                                                                                ...val,
                                                                                returnRequestsProductData: { ...val.returnRequestsProductData, selected: val.id === returnData.id, }
                                                                            })),
                                                                        };
                                                                    });
                                                                } else if (returnData?.status == 'Returned') {
                                                                    let reqStatus = ['Returned']
                                                                    setReturnStatus(reqStatus)
                                                                    let addkeyValues = { productName: product?.name, variantId: returnData?.variantId, productId: returnData?.productId }
                                                                    setSelectedReturnProduct(returnData)
                                                                    getRestoreInventoryLocation([addkeyValues])
                                                                }
                                                            }}
                                                            style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: handleReturnRequestColor(returnData?.status) + '15', paddingHorizontal: 8, paddingVertical: 4, borderRadius: 12 }}>
                                                            <ZenText content={returnData?.status} color={handleReturnRequestColor(returnData?.status)} size={width >= 600 ? fontSize.mediumFontSize : fontSize.smallFontSize} bold />
                                                            <ZenIcon name={returnData?.stockRestore ? 'check-all' : handleRequestIcon(returnData?.status)}
                                                                type='material-community' size={16} color={handleReturnRequestColor(returnData?.status)} style={{ marginLeft: 4 }}
                                                            />
                                                        </Pressable>
                                                    }
                                                />
                                            </View>
                                        ) : (
                                            <View style={{ alignItems: 'flex-end' }}>
                                                <ZenText content={product?.isFreeProduct ? "FREE" : `${CommonService.currencyStandard(currencySymbol, String(orderLineTotal(product)))}`} bold size={fontSize.mediumFontSize} color={product?.isFreeProduct ? appColors.green : appColors.primary} />
                                                {width >= 600 && <ZenText content='inclusive of all taxes' size={fontSize.badgeFontSize} color={appColors.lightFontColor} />}
                                            </View>
                                        )}
                                    </View>

                                    {product?.orderModifierList && product.orderModifierList.length > 0 && (
                                        <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginTop: 10, borderTopWidth: 1, borderTopColor: appColors.coolGray, paddingTop: 8 }}>
                                            {product.orderModifierList.map((modifierValue, key: number) => (
                                                <Pressable
                                                    key={key}
                                                    onPress={() => {
                                                        if (selectedStatus == 'Processing') {
                                                            setProductModifiers(null)
                                                            let removedElements = product?.orderModifierList
                                                            if (removedElements) {
                                                                handleUpdateProductModifiers(product, removedElements.filter((value) => value.modifierId != modifierValue?.modifierId) ?? [])
                                                            }
                                                        }
                                                    }}
                                                    style={{ backgroundColor: appColors.tealPrimary, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 8, paddingVertical: 4, borderRadius: 16, marginRight: 8, marginBottom: 4 }}>
                                                    <ZenText content={`${modifierValue?.optionValue} (+${CommonService.currencyStandard(currencySymbol, String(modifierValue?.price ?? 0))})`} size={fontSize.badgeFontSize} color={appColors.primary} />
                                                    {selectedStatus == 'Processing' && (
                                                        <ZenIcon name='close-circle' type='material-community' size={14} color={appColors.primary} style={{ marginLeft: 4 }} />
                                                    )}
                                                </Pressable>
                                            ))}
                                        </View>
                                    )}
                                </View>
                            </View>
                        </View> : null
                )) : null
        )
    }
    const ReturnRequestedListTemplate = ({ returnRequests, }: { returnRequests: ReturnRequestListType[] }) => {

        return (
            <View style={{ width: '100%' }}>
                {returnRequests?.map((item, index) => {

                    const productData = item?.returnRequestsProductData;
                    return (
                        <View key={`${item?.id}_${index}`} style={{ width: '95%', alignSelf: 'center', backgroundColor: appColors.light, borderRadius: 12, padding: 12, marginBottom: 12, shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3, borderWidth: 1, borderColor: appColors.coolGray }} >
                            <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                                {/* IMAGE */}
                                <View style={{ width: '18%', alignItems: 'center' }}>
                                    <Image source={item?.featuredImage ? { uri: config.AWSImageUrl + item?.featuredImage } : require('../../assets/pos.png')}
                                        style={{ width: 70, height: 70, borderRadius: 8, }} resizeMode="contain" />
                                </View>

                                {/* PRODUCT DETAILS */}
                                <View style={{ width: '28%' }}>
                                    <ZenText content={productData?.name || '-'} bold size={fontSize.mediumFontSize} />
                                    <ZenText content={`Item: ${item?.returnQty ?? 0}`} size={fontSize.smallFontSize} color={appColors.lightDark} style={{ marginTop: 4 }} />
                                </View>

                                {/* RETURN STATUS */}
                                <View style={{ width: '24%', alignItems: 'center', }} >
                                    <View style={{ flexDirection: 'row', alignItems: 'center', }} >
                                        <ZenText content={item?.status} color={handleReturnRequestColor(item?.status)} bold size={fontSize.mediumFontSize} />
                                    </View>
                                </View>
                                {/* TOTAL  */}
                                <View style={{ width: "10%" }}>
                                    <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(productData?.productWithOptionPrice ?? 0))}`} size={fontSize.mediumFontSize} color={appColors.dark} />
                                </View>

                                {/* ACTIONS */}
                                <View style={{ width: '20%', flexDirection: 'row', justifyContent: 'flex-end', gap: 20, alignItems: 'center', paddingRight: 10, }} >

                                    {/* CONTINUE ICON */}
                                    {(item?.status === "Approved" && selectedStatus !== "Pending") && selectedStatus !== "Returned" && <ZenIcon
                                        name='arrow-right-circle-outline'
                                        type='material-community'
                                        size={22}
                                        color={appColors.lightDark}
                                        onPress={() => {
                                            const productData = orderDetails?.orderedProductsList?.reduce(
                                                (result, orderProduct) => {
                                                    const returnedItem = orderProduct?.variantId === item?.variantId

                                                    if (returnedItem) {
                                                        result = {
                                                            ...orderProduct,
                                                            returnQty: item?.returnQty,
                                                            id: item?.id,
                                                            customizedOrderId: orderDetails?.customizedOrderId,
                                                            reason: item?.reason
                                                        };
                                                    }

                                                    return result;
                                                },
                                                {}
                                            );

                                            handleReturnRequestOrderForSellScreen(item?.action, false, String(item?.returnQty), productData, undefined, orderDetails)
                                        }}
                                    />}

                                    {/* VIEW ICON */}
                                    <ZenIcon
                                        name='eye'
                                        type='material-community'
                                        size={22}
                                        color={appColors.lightDark}
                                        onPress={() => { setSelectedReturnProduct(item); setReturnProductDetailsPopOver(true) }}
                                    />
                                </View>
                            </View>
                        </View>
                    );
                })}
            </View>
        );
    };

    const scrollToIndex = (index: number) => {
        let Item_Height = 70
        let findIndex = index
        let position = Item_Height * findIndex
        if (scrollRef.current) {

            scrollRef.current?.scrollTo({
                x: 0, // Assuming horizontal scrolling
                y: position, // Adjust itemHeight to match your item size
                animated: true,
            });
        }
        return index
    }
    const currentStatus = orderDetails?.orderStatusName


    const RightComponent = React.memo(({ isMobile }: { isMobile?: boolean }) => {
        const paymentStatus = orderDetails?.paymentOrders?.[0]?.status;
        const showContinueButton =
            isPos &&
            ((currentStatus === 'Pending') ||
                (paymentStatus === 'On Account' || paymentStatus === 'Partially Paid(On Account)' || paymentStatus === 'Partially Paid' || paymentStatus === 'Pending'));

        return (
            <View style={{ flexDirection: 'row', marginTop: 10, marginHorizontal: 10, alignItems: 'center', paddingLeft: 4, justifyContent: "flex-end" }}>
                {!orderDetails?.isDigitalOrder &&
                    <View style={{ gap: 10, flexDirection: "row", marginRight: 10 }}>
                        <ZenButton
                            title='View Changes'
                            titleStyle={{ fontSize: fontSize.tinyFontSize, color: appColors.light }}
                            buttonStyle={{ backgroundColor: appColors?.primary, borderRadius: 10, paddingHorizontal: 15, borderColor: 'transparent', borderWidth: 1 }}
                            containerStyle={{ borderRadius: 10, }}
                            onPress={() => { setChangeScreenVisible(true) }}
                        />
                        {isOrderWrite && <ZenButton
                            title='Send Bill'
                            titleStyle={{ fontSize: fontSize.tinyFontSize, color: appColors.light }}
                            buttonStyle={{ backgroundColor: appColors?.primary, borderRadius: 10, paddingHorizontal: 15, borderColor: 'transparent', borderWidth: 1 }}
                            containerStyle={{ borderRadius: 10, }}
                            onPress={() => { }}
                        />}

                        {showContinueButton && isSellScreenWrite && (
                            <ZenButton
                                title='Continue'
                                titleStyle={{ fontSize: fontSize.tinyFontSize, color: appColors.light }}
                                buttonStyle={{ backgroundColor: '#15803D', borderRadius: 10, paddingHorizontal: 15, borderColor: 'transparent', borderWidth: 1 }}
                                containerStyle={{ borderRadius: 10 }}
                                onPress={() => {
                                    const productData = orderDetails?.orderedProductsList?.reduce(
                                        (result, orderProduct) => {
                                            const returnedItem =
                                                orderDetails?.returnRequests?.find(
                                                    returnedItem => returnedItem?.variantId === orderProduct?.variantId
                                                );

                                            if (returnedItem) {
                                                result.push({
                                                    ...orderProduct,
                                                    returnQty: returnedItem.returnQty,
                                                    id: returnedItem?.id,
                                                    customizedOrderId: orderDetails?.customizedOrderId,
                                                    reason: returnedItem?.reason,
                                                    action: returnedItem?.action
                                                });
                                            }

                                            return result;
                                        },
                                        []
                                    );
                                    handleReturnRequestOrderForSellScreen(productData?.[0].action!, true, undefined, undefined, productData, orderDetails!)
                                }}
                            />
                        )}

                        {selectedStatus !== 'Returned' && isOrderWrite && hasReturnableItems() && isAllProductsAreReturnable() && (isWithinReturnWindow ? <ZenButton
                            title='Return Request'
                            titleStyle={{ fontSize: fontSize.tinyFontSize, color: appColors.light }}
                            buttonStyle={{ backgroundColor: appColors?.primary, borderRadius: 10, paddingHorizontal: 15, borderColor: 'transparent', borderWidth: 1 }}
                            containerStyle={{ borderRadius: 10, }}
                            onPress={() => {
                                setSelectedProduct(null)
                                setReturnRequestScreen(true)
                            }}
                        /> : <View style={{ justifyContent: 'center' }}>
                            <ZenText content={`Return window closed on ${returnDeadline?.format('MMM D, YYYY')}`} size={fontSize.smallFontSize} color={appColors.red} />
                        </View>)}
                    </View>
                }
            </View>
        )
    })

    const hasReturnRequests = orderDetails?.returnRequests && orderDetails.returnRequests.length > 0;
    const isReturned = currentStatus === 'Returned' || (hasReturnRequests && orderDetails.returnRequests.some(r => r.status === 'Returned'));
    const isParkedReturn = hasReturnRequests && orderDetails.returnRequests.some(r => r.status === 'Parked');
    const isParked = currentStatus === 'Parked';

    let dateLabel = "Ordered Date";
    let displayDate = orderDetails?.createdAt;

    if (isReturned) {
        dateLabel = "Returned Date";
        displayDate = orderDetails?.returnRequests?.[0]?.createdAt || orderDetails?.createdAt;
    } else if (isParkedReturn) {
        dateLabel = "Parked Date";
        displayDate = orderDetails?.returnRequests?.[0]?.createdAt || orderDetails?.createdAt;
    } else if (isParked) {
        dateLabel = "Parked Date";
        displayDate = orderDetails?.createdAt;
    }

    const getPaymentMethods = () => {

        if (!orderDetails?.paymentOrders || orderDetails.paymentOrders.length === 0) {
            return "N/A";
        }
        const methods = orderDetails.paymentOrders
            .filter((p: any) => p.status !== 'Refunded')
            .map((p: any) => p.paymentMode || p.paymentType || "Cash");
        const uniqueMethods = Array.from(new Set(methods));
        return uniqueMethods.length > 0 ? uniqueMethods.map((m: any) => String(m).replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase())).join(', ') : "Cash";
    };

    const getRefundMethods = () => {
        if (!orderDetails?.paymentOrders || orderDetails.paymentOrders.length === 0) {
            return "";
        }
        const methods = orderDetails.paymentOrders
            .filter((p: any) => p.status === 'Refunded')
            .map((p: any) => p.paymentMethod || p.paymentType || "Cash");
        const uniqueMethods = Array.from(new Set(methods));
        return uniqueMethods.map((m: any) => String(m).replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase())).join(', ');
    };

    const isAwaitingRefund = isParkedReturn;
    const refundAmount = orderDetails?.totalRefundAmount || 0;

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <KeyboardAvoidingView style={{ flex: 1 }} >
                    <CommonHeader
                        leftComponent={
                            <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
                                <TouchableOpacity onPress={() => navigation.goBack()}>
                                    <ZenIcon name={"arrow-left"} type={"material-community"} size={width > 600 ? 28 : 22} color={theme?.dark} />
                                </TouchableOpacity>

                                <View style={{}}>
                                    <ZenText content={`${!isOrderWrite ? "View " : ""} Order ${isLoading ? "Details" : "#" + orderDetails?.customizedOrderId ?? ''}`} bold={true} size={fontSize.largerFontSize} color={appColors.lightDark} />
                                    {!isLoading && <ZenText content='here you can customize the order' bold style={{ textTransform: 'capitalize' }} size={fontSize.mediumFontSize} />}
                                </View>
                            </View>}
                        headerName=''
                        rightComponent={isLandscape && !isLoading ? <RightComponent /> : null}
                    />

                    <View style={{ flex: 1 }}>
                        {
                            isLoading ?
                                <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                                    <ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={appColors?.primary} lottieType='Local' lottie={require('../../assets/infinityLoader.json')} />
                                </View> :
                                <View style=
                                    {{ flex: 1, backgroundColor: appColors.lightBackgroundColor }}>
                                    {width < height && <RightComponent isMobile={true} />}
                                    <ScrollView contentContainerStyle={{ paddingBottom: 20 }} nestedScrollEnabled={true}>
                                        <View style={{ width: '100%', marginTop: 10 }}>
                                            <View style={{ flexDirection: width > 800 ? 'row' : 'column', marginHorizontal: 10, marginVertical: width > 800 ? 15 : 0, gap: 15 }}>
                                                {/* ---------------- CUSTOMER DETAILS SECTION ---------------- */}
                                                <View
                                                    style={{
                                                        flex: width > 800 ? 1 : undefined,
                                                        width: width > 800 ? undefined : '100%',
                                                        backgroundColor: appColors.light,
                                                        padding: 20,
                                                        borderRadius: 12,
                                                        borderWidth: 1,
                                                        borderColor: appColors.coolGray,
                                                    }}
                                                >
                                                    <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 20 }}>
                                                        <ZenIcon name="account" type="material-community" size={24} color={appColors.primary} style={{ marginRight: 10 }} />
                                                        <ZenText content="Customer Details" style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                    </View>

                                                    {userDetails && (
                                                        <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                                                            <ZenAvatar
                                                                rounded
                                                                titleStyle={{ fontSize: 20, fontFamily: appFonts.bold }}
                                                                backgroundColor={appColors.primary}
                                                                title={handleAvatar(
                                                                    userDetails?.user?.firstName ?? '',
                                                                    userDetails?.user?.lastName ?? ''
                                                                )}
                                                                size={width > 800 ? 60 : 64}
                                                            // containerStyle={{ marginRight: 16 }}
                                                            />
                                                            <View style={{ flex: 1, marginLeft: 16 }}>
                                                                <ZenText content={`${userDetails?.user?.firstName} ${userDetails?.user?.lastName ?? ""}`} bold size={fontSize.largerFontSize} color={appColors.dark} />
                                                                {!!userDetails?.user?.email && (
                                                                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                        <ZenIcon name="email-outline" type="material-community" size={16} color={appColors.primary} style={{ marginRight: 6 }} />
                                                                        <ZenText content={userDetails?.user?.email} size={fontSize.smallFontSize} color={appColors.lightDark} />
                                                                    </View>
                                                                )}
                                                                {!!userDetails?.user?.phone && (
                                                                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                        <ZenIcon name="phone-outline" type="material-community" size={16} color={appColors.primary} style={{ marginRight: 6 }} />
                                                                        <ZenText content={userDetails?.user?.phone} size={fontSize.smallFontSize} color={appColors.lightDark} />
                                                                    </View>
                                                                )}
                                                            </View>
                                                        </View>
                                                    )}

                                                    <ZenDivider style={{ borderStyle: 'dashed', borderColor: appColors.coolGray, borderWidth: 0.5, marginVertical: 15 }} />

                                                    {!orderDetails?.isDigitalOrder && !isPos && (
                                                        <View style={{ marginBottom: 10 }}>
                                                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                                                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                    <View style={{ width: 32, height: 32, borderRadius: 16, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 10 }}>
                                                                        <ZenIcon name="map-marker-outline" type="material-community" size={18} color="#2563EB" />
                                                                    </View>
                                                                    <ZenText content={orderDetails?.shippingType === 'PICKUP' ? 'Pickup Address' : 'Delivery Address'} bold size={fontSize.mediumFontSize} color={appColors.primary} />
                                                                </View>
                                                                {(selectedStatus === 'Processing' && isPos) && (
                                                                    <Pressable onPress={() => setEditAddressVisible(true)} style={{ padding: 4 }}>
                                                                        <ZenIcon name="pencil-outline" type="material-community" color={appColors.primary} size={20} />
                                                                    </Pressable>
                                                                )}
                                                            </View>

                                                            <View style={{ backgroundColor: '#F8FAFC', padding: 6, borderRadius: 8 }}>
                                                                {orderDetails?.shippingType === 'PICKUP' ? (
                                                                    <>
                                                                        <ZenText content={orderDetails?.pickupAddress?.addressLine1} size={fontSize.mediumFontSize} color={appColors.dark} />
                                                                        {orderDetails?.pickupAddress?.doornumber && <ZenText content={orderDetails?.pickupAddress?.doornumber} size={fontSize.mediumFontSize} color={appColors.lightDark} />}
                                                                        <ZenText content={`${orderDetails?.pickupAddress?.city} - ${orderDetails?.pickupAddress?.zipCode}`} size={fontSize.mediumFontSize} color={appColors.lightDark} />
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <ZenText content={orderDetails?.deliveryAddress?.name} size={fontSize.mediumFontSize} bold color={appColors.dark} />
                                                                        <ZenText content={orderDetails?.deliveryAddress?.addressLine1} size={fontSize.mediumFontSize} color={appColors.lightDark} />
                                                                        {orderDetails?.deliveryAddress?.addressLine2 && <ZenText content={orderDetails?.deliveryAddress?.addressLine2} size={fontSize.mediumFontSize} color={appColors.lightDark} />}
                                                                        <ZenText content={`${orderDetails?.deliveryAddress?.city}, ${orderDetails?.deliveryAddress?.statename} - ${orderDetails?.deliveryAddress?.zipCode}`} size={fontSize.mediumFontSize} color={appColors.lightDark} />
                                                                    </>
                                                                )}
                                                            </View>
                                                        </View>
                                                    )}

                                                    {(userDetails && isPos) && (
                                                        <View style={{ flexDirection: 'row', gap: 10 }}>
                                                            {!!userDetails?.user?.email && isOrderWrite && (
                                                                <ZenButton
                                                                    title="Send Email"
                                                                    containerStyle={{ flex: 1 }}
                                                                    buttonStyle={{ backgroundColor: "#004B73", borderRadius: 8, height: 48 }}
                                                                    titleStyle={{ fontSize: fontSize.smallFontSize, color: appColors.light }}
                                                                    leftIcon={<ZenIcon name="email-outline" type="material-community" size={18} color={appColors.light} style={{ marginRight: 8 }} />}
                                                                    onPress={() => goToEmail(String(userDetails?.user?.email ?? ''))}
                                                                />
                                                            )}
                                                            {!!userDetails?.user?.phone && isOrderWrite && (
                                                                <ZenButton
                                                                    title="Call Customer"
                                                                    type="outline"
                                                                    containerStyle={{ flex: 1 }}
                                                                    outlineColor={appColors.coolGray}
                                                                    buttonStyle={{ borderRadius: 8, height: 48, borderColor: appColors.coolGray }}
                                                                    titleStyle={{ fontSize: fontSize.smallFontSize, color: appColors.dark }}
                                                                    leftIcon={<ZenIcon name="phone-outline" type="material-community" size={18} color={appColors.dark} style={{ marginRight: 8 }} />}
                                                                    onPress={() => goToTelePad(String(userDetails?.user?.phone ?? ''))}
                                                                />
                                                            )}
                                                        </View>
                                                    )}
                                                </View>

                                                {/* ---------------- GENERAL DETAILS SECTION ---------------- */}
                                                <View
                                                    style={{
                                                        flex: width > 800 ? 1 : undefined,
                                                        width: width > 800 ? undefined : '100%',
                                                        backgroundColor: appColors.light,
                                                        padding: 20,
                                                        borderRadius: 12,
                                                        borderWidth: 1,
                                                        borderColor: appColors.coolGray,
                                                    }}
                                                >
                                                    <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 20 }}>
                                                        <ZenIcon name="information-outline" type="material-community" size={24} color={appColors.primary} style={{ marginRight: 10 }} />
                                                        <ZenText content="General Details" style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                    </View>

                                                    <View style={{ gap: 16 }}>
                                                        {locationDetails && (
                                                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                    <ZenIcon name="location-outline" type="ionicon" size={20} color="#2563EB" />
                                                                </View>
                                                                <View>
                                                                    <ZenText content="Ordered Location" size={fontSize.smallFontSize} color={appColors.grey} />
                                                                    <ZenText content={locationDetails?.locationName} bold size={fontSize.mediumFontSize} color={appColors.dark} />
                                                                </View>
                                                            </View>
                                                        )}

                                                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                            <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                <ZenIcon name="calendar-outline" type="ionicon" size={20} color="#2563EB" />
                                                            </View>
                                                            <View>
                                                                <ZenText content={dateLabel} size={fontSize.smallFontSize} color={appColors.grey} />
                                                                <ZenText content={displayDate ? moment(new Date(displayDate)).format('MMM DD, YYYY - hh:mm:ss A') : ''} bold size={fontSize.mediumFontSize} color={appColors.dark} />
                                                            </View>
                                                        </View>

                                                        {!orderDetails?.isDigitalOrder && (
                                                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                    <ZenIcon name="truck-delivery-outline" type="material-community" size={20} color="#2563EB" />
                                                                </View>
                                                                <View>
                                                                    <ZenText content="Shipment Type" size={fontSize.smallFontSize} color={appColors.grey} />
                                                                    <ZenText content={isPos ? "Inperson Sale" : orderDetails?.shippingType ?? ''} bold size={fontSize.mediumFontSize} color={appColors.mayGreen} style={{ textTransform: 'uppercase' }} />
                                                                </View>
                                                            </View>
                                                        )}
                                                    </View>

                                                    <ZenDivider style={{ borderStyle: 'dashed', borderColor: appColors.coolGray, borderWidth: 0.5, marginVertical: 20 }} />

                                                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <View style={{ flex: 1, marginRight: 8 }}>
                                                            <ZenText content="Payment Status" size={fontSize.smallFontSize} color={appColors.grey} style={{ marginBottom: 6 }} />
                                                            <View
                                                                // disabled={!isUnpaid}
                                                                // onPress={() => isUnpaid && setPaymentStatusOpen(!paymentStatusOpen)}
                                                                style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#EFF6FF', paddingVertical: 8, paddingHorizontal: 12, borderRadius: 8, alignSelf: 'flex-start' }}
                                                            >
                                                                <ZenText content={selectedPaymentStatus || orderDetails?.paymentOrders?.[0]?.status} bold size={fontSize.smallFontSize} color="#1E40AF" />
                                                                {/* {(isUnpaid && isPos) && <ZenIcon name="chevron-down" type="material-community" size={16} color="#1E40AF" style={{ marginLeft: 4 }} />} */}
                                                            </View>
                                                            {/* {paymentStatusOpen && isUnpaid && (
                                                                    <View style={{ position: 'absolute', top: 60, left: 0, backgroundColor: '#fff', borderRadius: 8, elevation: 5, padding: 8, zIndex: 10, minWidth: 120 }}>
                                                                        <Pressable onPress={() => { setPaymentStatusOpen(false); setSelectedPaymentStatus('Paid Manually'); const paymentPROPS = statusProp?.propertyValueData?.find((i) => i.code === 'POS_PAYMENT_STATUS'); const status = paymentPROPS?.propertyValues?.find((s) => s.value === 'Paid'); if (status) handleUpdateOrderStatus('payment', status); }}>
                                                                            <ZenText content="Mark as Paid" size={fontSize.smallFontSize} />
                                                                        </Pressable>
                                                                    </View>
                                                                )} */}
                                                        </View>

                                                        <View style={{ flex: 1 }}>
                                                            <ZenText content="Fulfillment Status" size={fontSize.smallFontSize} color={appColors.grey} style={{ marginBottom: 6 }} />
                                                            <View
                                                                // disabled={!isStatusEditable || !isPos}
                                                                // onPress={() => isStatusEditable && (/* handleFullfillmentStatus(typeof selectedStatus == 'string' && selectedStatus ? selectedStatus : orderDetails?.orderStatusName!!), */ setFilterOpen(!filterOpen))}
                                                                style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#F0FDF4', paddingVertical: 8, paddingHorizontal: 12, borderRadius: 8, alignSelf: 'flex-start' }}
                                                            >
                                                                <ZenText content={currentStatus === "Pending" ? "Parked Return" : currentStatus} bold size={fontSize.smallFontSize} color="#15803D" style={{ textTransform: 'capitalize' }} />
                                                                {/* {(isStatusEditable && isPos) && <ZenIcon name="chevron-down" type="material-community" size={16} color="#15803D" style={{ marginLeft: 4 }} />} */}
                                                            </View>
                                                            {/* {filterOpen && isStatusEditable && (
                                                                    <View style={{
                                                                        position: 'absolute',
                                                                        top: 55,
                                                                        right: 0,
                                                                        backgroundColor: appColors.light,
                                                                        borderRadius: 12,
                                                                        minWidth: 180,
                                                                        overflow: 'hidden',
                                                                        shadowColor: '#000',
                                                                        shadowOffset: { width: 0, height: 4 },
                                                                        shadowOpacity: 0.12,
                                                                        shadowRadius: 8,
                                                                        elevation: 8,
                                                                        zIndex: 1000,
                                                                        borderWidth: 1,
                                                                        borderColor: '#E5E7EB',
                                                                    }}>
                                                                        {statusList?.map((val, key) => (
                                                                            <Pressable key={key} onPress={() => { setFilterOpen(false); setSelectedStatus(val?.value ?? ''); if (val.value === 'Shipped') { setTimeout(() => setTrackingVisible(true), 300); } else { handleUpdateOrderStatus('order', val); } }} style={{ paddingVertical: 8, paddingHorizontal: 12, borderBottomWidth: key === statusList.length - 1 ? 0 : 1, borderBottomColor: appColors.coolGray }}>
                                                                                <ZenText content={val.value} size={fontSize.smallFontSize} />
                                                                            </Pressable>
                                                                        ))}
                                                                    </View>
                                                                )} */}
                                                        </View>
                                                    </View>
                                                </View>

                                                {/* ---------------- AMOUNT DETAILS SECTION ---------------- */}
                                                <View
                                                    style={{
                                                        flex: width > 800 ? 1 : undefined,
                                                        width: width > 800 ? undefined : '100%',
                                                        backgroundColor: appColors.light,
                                                        padding: 20,
                                                        borderRadius: 12,
                                                        borderWidth: 1,
                                                        borderColor: appColors.coolGray,
                                                    }}
                                                >
                                                    <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 20 }}>
                                                        <ZenIcon name="wallet-outline" type="material-community" size={24} color={appColors.primary} style={{ marginRight: 10 }} />
                                                        <ZenText content="Amount Details" style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                    </View>

                                                    <View style={{ gap: 16 }}>
                                                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                            <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                <ZenIcon name="file-document-outline" type="material-community" size={20} color="#2563EB" />
                                                            </View>
                                                            <View>
                                                                <ZenText content="Grand Total" size={fontSize.smallFontSize} color={appColors.grey} />
                                                                <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(orderDetails?.totalAmount ?? 0))}`} bold size={fontSize.largerFontSize} color={appColors.dark} />
                                                            </View>
                                                        </View>

                                                        <ZenDivider style={{ borderColor: appColors.coolGray, borderWidth: 0.2 }} />

                                                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                            <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                <ZenIcon name="archive-outline" type="material-community" size={20} color="#2563EB" />
                                                            </View>
                                                            <View>
                                                                <ZenText content="Amount Paid" size={fontSize.smallFontSize} color={appColors.grey} />
                                                                <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(orderDetails?.amountPaid || '0'))}`} bold size={fontSize.largerFontSize} color={appColors.dark} />
                                                            </View>
                                                        </View>

                                                        <ZenDivider style={{ borderColor: appColors.coolGray, borderWidth: 0.2 }} />

                                                        <View style={{ flexDirection: 'row', alignItems: ((orderDetails?.paymentOrders?.[0]?.transactionData?.length ?? 0) > 1 ? 'flex-start' : 'center') }}>
                                                            <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                <ZenIcon name="cash-multiple" type="material-community" size={20} color="#2563EB" />
                                                            </View>
                                                            <View style={{ flex: 1 }}>
                                                                <ZenText content="Payment Method" size={fontSize.smallFontSize} color={appColors.grey} />
                                                                {
                                                                    (orderDetails?.paymentOrders?.[0]?.transactionData?.length ?? 0) > 0 ? (
                                                                        orderDetails?.paymentOrders?.[0]?.transactionData?.map((item: any, index: number) => (
                                                                            <View key={index} style={{ marginTop: index === 0 ? 2 : 6 }}>
                                                                                <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 6 }}>
                                                                                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                                                                                        <ZenText content={item?.paymentMode === "CASH IN" ? "CASH" : item?.paymentMode} bold size={fontSize.smallFontSize} color={appColors.dark} />
                                                                                        {item?.amount !== undefined && item?.amount !== null && (
                                                                                            <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(item?.amount ?? 0))}`} bold size={fontSize.smallFontSize} color={appColors.dark} />
                                                                                        )}
                                                                                    </View>
                                                                                    {(item?.paymentMode === "GIFT CARD PAYMENT" && orderDetails?.giftCardCoupenCode) && <TouchableOpacity style={{ flexDirection: "row", alignItems: "center", gap: 10 }} onPress={() => {
                                                                                        Clipboard.setString(orderDetails?.giftCardCoupenCode || "")
                                                                                        ZenToast({ message: 'Coupon Code Copied', type: "success" })
                                                                                    }}>
                                                                                        <ZenText bold color='#0369A1' content={orderDetails?.giftCardCoupenCode} size={fontSize.errorFontSize} style={{ letterSpacing: 1 }} />
                                                                                        <ZenIcon type="material-community" name="content-copy" size={17} color="#0284C7" />
                                                                                    </TouchableOpacity>}
                                                                                    {item?.createdAt && (
                                                                                        <ZenText content={moment(item?.createdAt).isValid() ? moment(item?.createdAt).format('MMM DD, YYYY - hh:mm A') : item?.createdAt} size={fontSize.smallFontSize} color={appColors.grey} />
                                                                                    )}
                                                                                </View>
                                                                                {item?.reason && (
                                                                                    <View style={{ marginTop: 2 }}>
                                                                                        <ZenText content={item?.reason} size={fontSize.smallFontSize} color={appColors.grey} />
                                                                                    </View>
                                                                                )}
                                                                            </View>
                                                                        ))
                                                                    ) : (
                                                                        <ZenText content={getPaymentMethods()} bold size={fontSize.mediumFontSize} color={appColors.dark} style={{ marginTop: 2 }} />
                                                                    )
                                                                }
                                                            </View>
                                                        </View>

                                                        {isAwaitingRefund && refundAmount > 0 && (
                                                            <>
                                                                <ZenDivider style={{ borderColor: appColors.coolGray, borderWidth: 0.2 }} />
                                                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                    <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#FEF2F2', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                        <ZenIcon name="cash-refund" type="material-community" size={20} color={appColors.red} />
                                                                    </View>
                                                                    <View>
                                                                        <ZenText content="Awaiting Refund" size={fontSize.smallFontSize} color={appColors.grey} />
                                                                        <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(refundAmount ?? 0))}`} bold size={fontSize.mediumFontSize} color={appColors.red} />
                                                                    </View>
                                                                </View>
                                                            </>
                                                        )}

                                                        {isReturned && refundAmount > 0 && (
                                                            <>
                                                                <ZenDivider style={{ borderColor: appColors.coolGray, borderWidth: 0.2 }} />
                                                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                    <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#FEF2F2', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                        <ZenIcon name="cash-refund" type="material-community" size={20} color={appColors.red} />
                                                                    </View>
                                                                    <View>
                                                                        <ZenText content="Refund Amount" size={fontSize.smallFontSize} color={appColors.grey} />
                                                                        <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(refundAmount ?? 0))}`} bold size={fontSize.mediumFontSize} color={appColors.red} />
                                                                    </View>
                                                                </View>

                                                                {getRefundMethods() !== "" && (
                                                                    <>
                                                                        <ZenDivider style={{ borderColor: appColors.coolGray, borderWidth: 0.2 }} />
                                                                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                            <View style={{ width: 44, height: 44, borderRadius: 22, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 15 }}>
                                                                                <ZenIcon name="credit-card-outline" type="material-community" size={20} color="#2563EB" />
                                                                            </View>
                                                                            <View>
                                                                                <ZenText content="Refund Method" size={fontSize.smallFontSize} color={appColors.grey} />
                                                                                <ZenText content={getRefundMethods()} bold size={fontSize.mediumFontSize} color={appColors.dark} />
                                                                            </View>
                                                                        </View>
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </View>
                                                </View>

                                            </View>



                                            <View style={{ flexDirection: width > 800 ? 'row' : 'column', marginHorizontal: 10, marginTop: 10, }}>

                                                <View style={{ width: width > 800 ? '59%' : '100%', overflow: 'hidden', borderRadius: 7, backgroundColor: appColors.light, paddingVertical: 10, }}>
                                                    {/* orderProductList------------- */}

                                                    <View style={{ width: '100%', backgroundColor: appColors.light, paddingVertical: 15 }}>

                                                        <View style={{ marginHorizontal: 20, marginBottom: 15, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <View>
                                                                <ZenText content='Ordered Products' style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                                <ZenText
                                                                    content={`number of ordered products : `}
                                                                    size={fontSize.largerFontSize}
                                                                    style={{ textTransform: 'capitalize', color: appColors.dark }}
                                                                    children={
                                                                        <ZenText style={{ color: appColors.lightDark }} bold content={handleProductCount(orderDetails?.orderedProductsList ? orderDetails?.orderedProductsList : [])} />} />
                                                            </View>

                                                            {
                                                                enableRestoreStock && isOrderWrite &&
                                                                <ZenButton
                                                                    title='RestoreStock'
                                                                    type='outline'
                                                                    outlineColor={appColors.primary}
                                                                    onPress={() => {
                                                                        if (allReturnedStock) {
                                                                            getRestoreInventoryLocation(allReturnedStock)
                                                                        }
                                                                        else {
                                                                            // console.log("-----else-allReturnedStock", allReturnedStock);
                                                                        }
                                                                    }
                                                                    }
                                                                    buttonStyle={{ paddingHorizontal: 5, paddingVertical: 0, borderRadius: 5 }}
                                                                />
                                                            }
                                                        </View>
                                                        <View style={{ width: '100%' }}>
                                                            <ListTemplate orderedProductsList={orderDetails?.orderedProductsList ? orderDetails?.orderedProductsList : []} />
                                                            {(orderDetails?.staffName || orderDetails?.userName) && (
                                                                <View style={{ flexDirection: 'row', justifyContent: 'flex-end', paddingHorizontal: 20, marginTop: 10 }}>
                                                                    <ZenText content="Cashier: " size={fontSize.smallFontSize} color={appColors.lightDark} />
                                                                    <ZenText content={orderDetails?.staffName || orderDetails?.userName} bold size={fontSize.smallFontSize} color={appColors.dark} />
                                                                </View>
                                                            )}
                                                        </View>

                                                    </View>

                                                    {/* Return requested products */}

                                                    {
                                                        orderDetails?.returnRequests && orderDetails?.returnRequests?.length > 0 &&
                                                        <View style={{ width: '100%', backgroundColor: appColors.light, paddingVertical: 15, borderTopWidth: 1, borderTopColor: appColors.coolGray, marginTop: 10 }}>
                                                            <View style={{ marginHorizontal: 20, marginVertical: 10, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <View>
                                                                    <ZenText content='Return Requested products' bold style={{ textTransform: 'capitalize', color: appColors.primary, fontSize: fontSize?.headerFontSize }} />
                                                                </View>
                                                                {/* {selectedStatus == 'Processing' && */}

                                                                {/* } */}
                                                            </View>
                                                            <View style={{ width: '100%' }}>
                                                                <ReturnRequestedListTemplate returnRequests={orderDetails?.returnRequests ?? []} />
                                                            </View>
                                                            {/* {
                                                                    orderDetails?.returnRequests.map((data, indxes: number) => (
                                                                        <ListTemplate key={`return_${data.id}`}
                                                                            orderedProductsList={data?.returnRequestsProductData} returnData={data} />
                                                                    ))
                                                                } */}
                                                        </View>
                                                    }

                                                    {loyaltyHistory && loyaltyHistory.length > 0 && (
                                                        <View style={{ width: '100%', backgroundColor: appColors.light, paddingVertical: 15, borderTopWidth: 1, borderTopColor: appColors.coolGray, marginTop: 10 }}>
                                                            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 15, marginHorizontal: 20 }}>
                                                                <ZenIcon name="star-circle-outline" type="material-community" size={24} color={appColors.primary} style={{ marginRight: 10 }} />
                                                                <ZenText content="Loyalty Points Earn History" style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                            </View>
                                                            <View style={{ marginHorizontal: 20 }}>
                                                                <View style={{ borderRadius: 12, borderWidth: 1, borderColor: appColors.coolGray, overflow: 'hidden' }}>
                                                                    <View style={{ flexDirection: 'row', backgroundColor: appColors.light, paddingVertical: 15, paddingHorizontal: 10, borderBottomWidth: 1, borderBottomColor: appColors.coolGray }}>
                                                                        <ZenText content='Adjustment Date' bold style={{ flex: 1, color: appColors.dark, fontSize: fontSize.smallFontSize, textAlign: 'center' }} />
                                                                        <ZenText content='Points' bold style={{ flex: 1, color: appColors.dark, fontSize: fontSize.smallFontSize, textAlign: 'center' }} />
                                                                        <ZenText content='Adjustment Reason' bold style={{ flex: 1, color: appColors.dark, fontSize: fontSize.smallFontSize, textAlign: 'center' }} />
                                                                        <ZenText content='Adjustment Type' bold style={{ flex: 1, color: appColors.dark, fontSize: fontSize.smallFontSize, textAlign: 'center' }} />
                                                                    </View>
                                                                    {loyaltyHistory.map((item, index) => (
                                                                        <View key={index} style={{ flexDirection: 'row', backgroundColor: index % 2 === 0 ? appColors.coolGray : appColors.light, paddingVertical: 12, paddingHorizontal: 10 }}>
                                                                            <ZenText content={item?.createdAt ? moment(item.createdAt).format('MMMM DD, YYYY') : '-'} style={{ flex: 1, color: appColors.grey, fontSize: fontSize.smallFontSize, textAlign: 'center' }} />
                                                                            <ZenText content={item?.points} style={{ flex: 1, color: appColors.grey, fontSize: fontSize.smallFontSize, textAlign: 'center' }} />
                                                                            <ZenText content={item?.reason} style={{ flex: 1, color: appColors.grey, fontSize: fontSize.smallFontSize, textAlign: 'center' }} />
                                                                            <ZenText content={item?.event} style={{ flex: 1, color: appColors.grey, fontSize: fontSize.smallFontSize, textAlign: 'center' }} />
                                                                        </View>
                                                                    ))}
                                                                </View>
                                                            </View>
                                                        </View>
                                                    )}

                                                    {refundHistory && refundHistory.length > 0 && (
                                                        <View style={{ width: '100%', backgroundColor: appColors.light, paddingVertical: 15, borderTopWidth: 1, borderTopColor: appColors.coolGray, marginTop: 10 }}>
                                                            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 15, marginHorizontal: 20 }}>
                                                                <ZenIcon name="cash-refund" type="material-community" size={24} color={appColors.primary} style={{ marginRight: 10 }} />
                                                                <ZenText content="Refund History" style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                            </View>
                                                            <View style={{ marginHorizontal: 20 }}>
                                                                <View style={{ borderRadius: 12, borderWidth: 1, borderColor: appColors.coolGray, overflow: 'hidden' }}>
                                                                    <View style={{ flexDirection: 'row', backgroundColor: appColors.light, paddingVertical: 15, paddingHorizontal: 10, borderBottomWidth: 1, borderBottomColor: appColors.coolGray }}>
                                                                        <ZenText content='Refund Date' bold style={{ flex: 1, textAlign: 'center', color: appColors.dark, fontSize: fontSize.smallFontSize }} />
                                                                        <ZenText content='Amount' bold style={{ flex: 1, textAlign: 'center', color: appColors.dark, fontSize: fontSize.smallFontSize }} />
                                                                        <ZenText content='Status' bold style={{ flex: 1, textAlign: 'center', color: appColors.dark, fontSize: fontSize.smallFontSize }} />
                                                                        <ZenText content='Refund Reason' bold style={{ flex: 1, textAlign: 'center', color: appColors.dark, fontSize: fontSize.smallFontSize }} />
                                                                        <ZenText content='Refund Type' bold style={{ flex: 1, textAlign: 'center', color: appColors.dark, fontSize: fontSize.smallFontSize }} />
                                                                    </View>
                                                                    {refundHistory.map((item, index) => (
                                                                        <View key={index} style={{ flexDirection: 'row', backgroundColor: index % 2 === 0 ? appColors.coolGray : appColors.light, paddingVertical: 12, paddingHorizontal: 10 }}>
                                                                            <ZenText content={item?.createdAt ? moment(item.createdAt).format('MMMM DD, YYYY') : '-'} style={{ flex: 1, textAlign: 'center', color: appColors.grey, fontSize: fontSize.smallFontSize }} />
                                                                            <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(item?.refundAmount ?? 0))}`} style={{ flex: 1, textAlign: 'center', color: appColors.grey, fontSize: fontSize.smallFontSize }} />
                                                                            <ZenText content={item?.refundStatus} style={{ flex: 1, textAlign: 'center', color: appColors.grey, fontSize: fontSize.smallFontSize }} />
                                                                            <ZenText content={item?.refundReason} style={{ flex: 1, textAlign: 'center', color: appColors.grey, fontSize: fontSize.smallFontSize }} />
                                                                            <ZenText content={item?.refundType} style={{ flex: 1, textAlign: 'center', color: appColors.grey, fontSize: fontSize.smallFontSize }} />
                                                                        </View>
                                                                    ))}
                                                                </View>
                                                            </View>
                                                        </View>
                                                    )}

                                                </View>

                                                {/*Invoice------------- */}

                                                <View style={{ width: width > 800 ? '40%' : '100%', marginLeft: width > 800 ? 10 : 0, paddingVertical: width > 800 ? 0 : 15, }}>

                                                    {/* orderInvoice------------- */}

                                                    <View style={{ width: '100%', backgroundColor: appColors.light, borderRadius: 7, }}>

                                                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 10, paddingVertical: 15 }}>
                                                            <ZenText content='Order Invoice' style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                            {<ZenButton
                                                                title='Send Receipt'
                                                                outlineColor={appColors.lightGrey}
                                                                containerStyle={{ width: width > height ? 'auto' : '40%', height: 40, }}
                                                                titleStyle={{ fontSize: fontSize.smallFontSize, textTransform: 'capitalize', color: appColors.lightDark }}
                                                                type='outline'
                                                                leftIcon={<ZenIcon name='print' type='material' style={{ marginRight: width > height ? 10 : 5 }} />}
                                                                onPress={handleOpenSendReceiptModal}
                                                                buttonStyle={{ borderRadius: 10, paddingHorizontal: 5 }}
                                                            />}
                                                            <ZenButton
                                                                title='print'
                                                                outlineColor={appColors.lightGrey}
                                                                containerStyle={{ width: '25%', height: 40, }}
                                                                titleStyle={{ fontSize: fontSize.smallFontSize, textTransform: 'capitalize', color: appColors.lightDark }}
                                                                type='outline'
                                                                leftIcon={<ZenIcon name='print' type='material' style={{ marginRight: 10 }} />}
                                                                onPress={() => { getOrderInvoice() }}
                                                                buttonStyle={{ borderRadius: 10 }}
                                                            />
                                                        </View>
                                                        <View style={{ marginHorizontal: 15, marginVertical: 15 }}>
                                                            {orderDetails ?
                                                                <>
                                                                    <TextTemplate amount={orderDetails?.subTotal} name='order subTotal' />
                                                                    {discountSummary.hasBreakdown ? <>
                                                                        {discountSummary.itemDiscount > 0 && <TextTemplate amount={discountSummary.itemDiscount} name='item discounts (-)' />}
                                                                        {discountSummary.couponDiscount > 0 && <TextTemplate amount={discountSummary.couponDiscount} name={`coupon${discountSummary.couponCodes.length ? ` (${discountSummary.couponCodes.join(', ')})` : ''} (-)`} />}
                                                                        {discountSummary.additionalDiscount > 0 && <TextTemplate amount={discountSummary.additionalDiscount} name='additional discount (-)' />}
                                                                        {discountSummary.freeItemsValue > 0 && <TextTemplate amount={discountSummary.freeItemsValue} name='free items (not charged)' />}
                                                                    </> :
                                                                        <TextTemplate amount={orderDetails?.discountAmount} name={isPos ? 'discount (-)' : 'coupon discount (-)'} />
                                                                    }
                                                                    <TextTemplate amount={orderDetails?.subTotal - Number(orderDetails?.discountAmount)} name='discounted price' />
                                                                    <TextTemplate amount={orderDetails?.taxAmount} name='Tax' />
                                                                    {/* <TextTemplate amount={orderDetails?.shippingRate || orderDetails?.shippingrate} name='shipping charges' /> */}
                                                                    {/* <TextTemplate amount={orderDetails?.serviceCharge} name='handling fee' /> */}
                                                                    <TextTemplate amount={orderDetails?.additionalCharge} name='Additional Charges' />
                                                                    <TextTemplate amount={typeof orderDetails?.tipAmount === 'object' ? orderDetails?.tipAmount?.amount : orderDetails?.tipAmount} name='Tip' />
                                                                    {roundOffDetails.roundOff ? <>
                                                                        <TextTemplate amount={orderDetails?.totalAmount} name='Total' />
                                                                        <TextTemplate amount={Math.abs(roundOffDetails.roundOff).toFixed(2)} name={`Round Off (${roundOffDetails.roundOff > 0 ? "+" : "-"})`} />
                                                                    </> : null}
                                                                    {orderDetails?.codAmount > 0 && <TextTemplate amount={orderDetails?.codAmount} name='cod charges' />}
                                                                    <ZenDivider style={{ marginVertical: 10, backgroundColor: appColors.dark }} />
                                                                    {/* <TextTemplate amount={orderDetails?.totalAmount} name='Total order amount' /> */}
                                                                    {/* <TextTemplate amount={orderDetails?.usedGiftCardAmount} name='giftCardAmount' /> */}
                                                                    <TextTemplate amount={roundOffDetails.roundOff ? roundOffDetails.payableTotal : orderDetails?.totalAmount} name='Grand Total' />
                                                                    <TextTemplate amount={orderDetails?.paymentOrders?.find(paymentOrder => paymentOrder?.paymentMode === "CASH IN")?.paidAmount || "0"} name='Cash' />
                                                                    <TextTemplate amount={orderDetails?.paymentOrders?.find(paymentOrder => paymentOrder?.paymentMode === "CASH IN")?.balance || "0"} name='Change (-)' />
                                                                    {/* <TextTemplate amount={(Number(orderDetails?.totalAmount || 0) - Number(orderDetails?.amountPaid || 0)).toFixed(2)} name='To pay' /> */}
                                                                    {/* <TextTemplate amount={orderDetails?.amountPaid} name='payable/ paid amount' /> */}
                                                                    <TextTemplate amount={discountSummary.hasBreakdown ? discountSummary.totalSavings : (orderDetails?.discountAmount || "0")} name='Total savings' />
                                                                </> : null
                                                            }
                                                            {
                                                                !orderDetails?.isInclusiveTax && orderDetails?.taxDetails?.map((taxValue, index: number) =>
                                                                (
                                                                    <TextTemplate key={index} amount={taxValue?.taxAmount} name={taxValue?.taxName} />
                                                                ))
                                                            }
                                                        </View>
                                                    </View>

                                                    {/* manualDicount------------- */}

                                                    {!isPos && <View style={{ backgroundColor: appColors.light, width: '100%', paddingHorizontal: 20, paddingVertical: 20, marginTop: 10, borderRadius: 12, borderWidth: 1, borderColor: appColors.coolGray }}>
                                                        <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
                                                            <ZenText content='Available Offers' style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                            {(selectedStatus == 'Processing' && isPos) && (
                                                                <ZenButton
                                                                    title='Apply Offers'
                                                                    type='outline'
                                                                    containerStyle={{ height: 40 }}
                                                                    titleStyle={{ fontSize: fontSize.smallFontSize }}
                                                                    outlineColor={appColors.primary}
                                                                    buttonStyle={{ borderRadius: 10 }}
                                                                    onPress={() => { getOrderDiscountDetail() }}
                                                                />
                                                            )}
                                                        </View>

                                                        {handleDiscountDetails(orderDetails?.discountDetails ?? []).length > 0 ? (
                                                            <View style={{
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                padding: 12,
                                                                borderRadius: 8,
                                                                backgroundColor: appColors.tealPrimary,
                                                                borderWidth: 1,
                                                                borderStyle: 'dashed',
                                                                borderColor: appColors.primary
                                                            }}>
                                                                <ZenIcon name='tag' type='font-awesome' size={16} color={appColors.primary} style={{ marginRight: 8 }} />
                                                                <ZenText
                                                                    content={handleDiscountDetails(orderDetails?.discountDetails ?? [])}
                                                                    bold
                                                                    style={{ letterSpacing: 1 }}
                                                                    color={appColors.primary}
                                                                    size={fontSize.mediumFontSize}
                                                                />
                                                            </View>
                                                        ) : (
                                                            <View style={{ padding: 10, backgroundColor: appColors.softSlate, borderRadius: 8, alignItems: 'center' }}>
                                                                <ZenText content='No applicable coupons found' color={appColors.lightDark} size={fontSize.smallFontSize} />
                                                            </View>
                                                        )}
                                                    </View>}



                                                    {/* customerNotes------------- */}
                                                    {!!orderDetails?.customerNotes && (
                                                        <View style={{ backgroundColor: appColors.light, width: '100%', marginTop: 12, paddingVertical: 20, paddingHorizontal: 20, borderRadius: 12, borderWidth: 1, borderColor: appColors.coolGray, shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.05, shadowRadius: 4, elevation: 2, }}>
                                                            <ZenText content='Customer Notes' style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize, marginBottom: 15 }} bold />
                                                            <View style={{ padding: 12, backgroundColor: appColors.lightBackgroundColor, borderRadius: 10, borderWidth: 1, borderColor: appColors.coolGray }}>
                                                                <ZenText content={orderDetails?.customerNotes} size={fontSize.mediumFontSize} color={appColors.dark} />
                                                            </View>
                                                        </View>
                                                    )}



                                                    {/* orderNotes------------- */}

                                                    <View style={{ backgroundColor: appColors.light, width: '100%', marginTop: 12, paddingVertical: 20, paddingHorizontal: 20, borderRadius: 12, borderWidth: 1, borderColor: appColors.coolGray, shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.05, shadowRadius: 4, elevation: 2, }}>
                                                        <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
                                                            <ZenText content='Staff Notes' style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                            {(isPos && !showAddNoteField) && isOrderWrite && (
                                                                <ZenButton
                                                                    title='+Notes'
                                                                    type='outline'
                                                                    containerStyle={{ height: 40 }}
                                                                    titleStyle={{ fontSize: fontSize.smallFontSize }}
                                                                    outlineColor={appColors.primary}
                                                                    buttonStyle={{ borderRadius: 10, paddingHorizontal: 15 }}
                                                                    onPress={() => setShowAddNoteField(true)}
                                                                />
                                                            )}
                                                        </View>

                                                        {/* Input Area */}
                                                        {(isPos && showAddNoteField) && (
                                                            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 20, gap: 10 }}>
                                                                <ZenInput
                                                                    value={noteInput}
                                                                    onChangeText={setNoteInput}
                                                                    placeholder='Add a note...'
                                                                    containerStyle={{ flex: 1, height: 45 }}
                                                                    inputContainerStyle={{ borderRadius: 8, borderWidth: 1, borderColor: appColors.coolGray, paddingHorizontal: 10 }}
                                                                />
                                                                <ZenButton
                                                                    onPress={() => {
                                                                        handleAddNote();
                                                                        setShowAddNoteField(false);
                                                                    }}
                                                                    title='Save'
                                                                    buttonStyle={{ borderRadius: 8, height: 45, paddingHorizontal: 15, backgroundColor: appColors.primary }}
                                                                />
                                                                <ZenButton
                                                                    onPress={() => {
                                                                        setNoteInput('');
                                                                        setShowAddNoteField(false);
                                                                    }}
                                                                    title='Cancel'
                                                                    type='clear'
                                                                    titleStyle={{ color: appColors.red, fontSize: fontSize.smallFontSize }}
                                                                />
                                                            </View>
                                                        )}


                                                        {/* Notes List */}
                                                        <View>
                                                            {orderNotes.length > 0 ? orderNotes.map((noteVal, noteInd) => (
                                                                <View key={noteInd} style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 12, paddingHorizontal: 15, backgroundColor: appColors.lightBackgroundColor, borderRadius: 10, marginBottom: 10, borderWidth: 1, borderColor: appColors.coolGray }}>
                                                                    <View style={{ flex: 1, marginRight: 10 }}>
                                                                        {editingNoteId === noteVal.id ? (
                                                                            <ZenInput
                                                                                value={noteVal.notes}
                                                                                onChangeText={(val) => {
                                                                                    const updated = [...orderNotes];
                                                                                    updated[noteInd].notes = val;
                                                                                    setOrderNotes(updated);
                                                                                }}
                                                                                autoFocus
                                                                                containerStyle={{ height: 40 }}
                                                                                inputContainerStyle={{ borderBottomWidth: 1 }}
                                                                            />
                                                                        ) : (
                                                                            <ZenText content={noteVal.notes} size={fontSize.mediumFontSize} color={appColors.dark} />
                                                                        )}
                                                                    </View>
                                                                    {isPos &&
                                                                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                                            {editingNoteId === noteVal.id ? (
                                                                                <ZenIcon
                                                                                    name='check'
                                                                                    type='material-community'
                                                                                    size={22}
                                                                                    color={appColors.green}
                                                                                    style={{ marginRight: 15 }}
                                                                                    onPress={() => {
                                                                                        handleOrderNotes(noteVal);
                                                                                        setEditingNoteId(null);
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <ZenIcon
                                                                                    name='pencil'
                                                                                    type='octicon'
                                                                                    size={20}
                                                                                    color={appColors.primary}
                                                                                    style={{ marginRight: 15 }}
                                                                                    onPress={() => setEditingNoteId(noteVal.id)}
                                                                                />
                                                                            )}
                                                                            <ZenIcon
                                                                                name='delete'
                                                                                type='material-community'
                                                                                size={22}
                                                                                color={appColors.red}
                                                                                onPress={() => handleOrderNotes(noteVal, 'Delete')}
                                                                            />
                                                                        </View>
                                                                    }

                                                                </View>
                                                            )) : (
                                                                <View style={{ padding: 10, alignItems: 'center', justifyContent: "center", backgroundColor: appColors.softSlate, flexDirection: "row", gap: 10, borderRadius: 10 }}>
                                                                    <ZenIcon name='note-outline' type='material-community' size={24} color={appColors.disabledGray500} />
                                                                    <ZenText content='No notes added yet' color={appColors.disabledGray500} size={fontSize.smallFontSize} />
                                                                </View>
                                                            )}
                                                        </View>
                                                    </View>



                                                    {/* shippingDetails------------- */}
                                                    {!orderDetails?.isDigitalOrder && !isPos ?
                                                        <View style={{ width: '100%', marginTop: 10, paddingVertical: 15, backgroundColor: appColors.light, borderRadius: 7, }}>
                                                            <View style={{ backgroundColor: appColors.light, padding: 15 }}>
                                                                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                                                                    <ZenText content='Shipping Details' style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize, marginBottom: 15 }} bold />
                                                                    {(selectedStatus == 'Shipped' || selectedStatus == 'Processing') && isOrderWrite &&
                                                                        <ZenButton
                                                                            onPress={() => getShippingMethods()}
                                                                            icon={<ZenIcon name='pencil' type='octicon' color={appColors.primary} size={24} />}
                                                                            title=''
                                                                            buttonStyle={{ height: 45, width: 45, marginLeft: 10, backgroundColor: appColors?.light }}
                                                                        />
                                                                    }
                                                                </View>

                                                                <View style={{ alignItems: 'flex-start', paddingLeft: 20 }}>
                                                                    {shippingData && <IconTemplate
                                                                        content1='Delivery Method'
                                                                        content2={shippingData?.name}
                                                                        iconColor={appColors.lightDarkBlue}
                                                                        type={'material-community'}
                                                                        name="truck-delivery"
                                                                    />
                                                                    }
                                                                    <IconTemplate
                                                                        content1='Delivery Partner'
                                                                        content2={`${shippingData?.shippingType}`}
                                                                        iconColor={appColors.lightDarkBlue}
                                                                        type={'material-community'}
                                                                        name="account-tie" />
                                                                    <IconTemplate
                                                                        content1='Expected Delivery Date'
                                                                        content2={`${orderDetails?.expectedDate}`}
                                                                        iconColor={appColors.lightDarkBlue}
                                                                        type={'material'}
                                                                        name="event"
                                                                    />

                                                                    {orderDetails?.trackingId &&
                                                                        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                            <IconTemplate
                                                                                content1='Tracking Details'
                                                                                content2={String(orderDetails?.trackingId)}
                                                                                iconColor={appColors.lightDarkBlue}
                                                                                type={'material-community'}
                                                                                name="map-marker-path"
                                                                            />
                                                                            {selectedStatus == 'Shipped' && <ZenIcon name='pencil' type='octicon' size={20} onPress={() => {
                                                                                setTrackingData(String(orderDetails?.trackingId))
                                                                                setTrackingVisible(true)
                                                                            }
                                                                            } />}
                                                                        </View>}


                                                                </View>

                                                            </View>

                                                        </View> : null
                                                    }

                                                    {/* refund Amount */}
                                                    {(selectedStatus == 'Delivered' || selectedStatus == 'Packed') && !isPos &&
                                                        <View style={{ backgroundColor: appColors.light, width: '100%', paddingHorizontal: 20, paddingVertical: 20, marginTop: 10, borderRadius: 12, borderWidth: 1, borderColor: appColors.coolGray }}>
                                                            <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
                                                                <ZenText content='Cash Payment Refund' style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                                <ZenIcon name='information-outline' type='material-community' size={20} color={appColors.lightDark} />
                                                            </View>
                                                            <View style={{ marginBottom: 15 }}>
                                                                <ZenText
                                                                    content={`Available Amount for Refund : ${CommonService.currencyStandard(currencySymbol, String((orderDetails?.totalRefundAmount ? Number(orderDetails?.totalAmount) - orderDetails?.totalRefundAmount : orderDetails?.totalAmount) ?? 0))}`}
                                                                    bold
                                                                    style={{ color: appColors.grey }}
                                                                    size={fontSize.mediumFontSize}
                                                                />
                                                            </View>
                                                            {isOrderWrite && <ZenButton
                                                                title={'Refund Amount'}
                                                                containerStyle={{ height: 44 }}
                                                                buttonStyle={{ borderRadius: 8, backgroundColor: appColors?.primary }}
                                                                titleStyle={{ fontSize: fontSize.mediumFontSize, fontFamily: appFonts.bold }}
                                                                onPress={() => {
                                                                    setFormValue('')
                                                                    setReasonValue('')
                                                                    setRefundVisible(true)
                                                                }}
                                                            />}
                                                        </View>
                                                    }

                                                    {/* loyaltypoints */}
                                                    {(orderDetails?.availablePointsToRedeem || orderDetails?.earningPoints) && !isPos &&
                                                        (selectedStatus == 'Packed' || selectedStatus == 'Delivered') &&
                                                        <View style={{ backgroundColor: appColors.light, width: '100%', paddingHorizontal: 20, paddingVertical: 20, marginTop: 10, borderRadius: 12, borderWidth: 1, borderColor: appColors.coolGray }}>
                                                            <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
                                                                <ZenText content='Loyalty Points Adjustment' style={{ color: appColors.primary, fontSize: fontSize?.headerFontSize }} bold />
                                                                <ZenIcon name='information-outline' type='material-community' size={20} color={appColors.lightDark} />
                                                            </View>
                                                            <View style={{ marginBottom: 15 }}>
                                                                <ZenText
                                                                    content={`Available Redeem Points : ${orderDetails?.availablePointsToRedeem ?? orderDetails?.earningPoints}`}
                                                                    bold
                                                                    style={{ color: appColors.grey }}
                                                                    size={fontSize.mediumFontSize}
                                                                />
                                                                {isOrderWrite && <ZenButton
                                                                    title={'Adjust Points'}
                                                                    containerStyle={{ height: 44 }}
                                                                    buttonStyle={{ borderRadius: 8, backgroundColor: appColors?.primary }}
                                                                    titleStyle={{ fontSize: fontSize.mediumFontSize, fontFamily: appFonts.bold }}
                                                                    onPress={() => {
                                                                        setReasonValue('')
                                                                        setFormValue('')
                                                                        setFullAdjustment(false)
                                                                        setLoyaltyVisible(true)
                                                                    }}
                                                                />}
                                                            </View>
                                                        </View>
                                                    }

                                                </View>
                                            </View>

                                        </View>
                                    </ScrollView>
                                </View >
                        }
                    </View >




                    {/* dicountList Screen */}
                    <Popover isVisible={discountListVisible}>
                        <View style={{ height: height * 0.7, width: width > 600 ? 500 : width - 30, backgroundColor: appColors.lightBackgroundColor, overflow: 'hidden', borderRadius: 16 }}>

                            {/* Header */}
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 16, paddingHorizontal: 20, backgroundColor: appColors.light, borderBottomWidth: 1, borderBottomColor: appColors.coolGray }}>
                                <ZenText content='Apply Coupon' bold size={fontSize.headerFontSize} color={appColors.primary} style={{ textTransform: 'capitalize' }} />
                                <ZenIcon name='close' type='material' size={24} color={appColors.dark} onPress={() => {
                                    setDiscountListVisble(false)
                                }} />
                            </View>

                            {/* Manual Input Section */}
                            <View style={{ backgroundColor: appColors.light, padding: 20, borderBottomWidth: 1, borderBottomColor: appColors.coolGray }}>
                                <ZenInput
                                    placeholder='Enter coupon code'
                                    value={couponCode ? couponCode : ''}
                                    inputContainerStyle={{ backgroundColor: appColors.softSlate, paddingHorizontal: 12, borderRadius: 8, borderBottomWidth: 0, height: 50 }}
                                    containerStyle={{ width: '100%', marginBottom: 12 }}
                                    onChangeText={(val) => {
                                        setCouponCode(val)
                                    }}
                                />
                                <ZenButton
                                    title='Redeem Coupon'
                                    disabled={!couponCode}
                                    containerStyle={{ width: '100%', height: 48 }}
                                    buttonStyle={{ backgroundColor: appColors.primary, borderRadius: 8 }}
                                    titleStyle={{ fontSize: fontSize.mediumFontSize, fontFamily: appFonts.bold }}
                                    onPress={() => {
                                        handleUpdateOrderDiscount()
                                    }}
                                />
                            </View>

                            <ScrollView ref={scrollRef} contentContainerStyle={{ padding: 16 }}>
                                <View style={{ marginBottom: 16 }}>
                                    <ZenText content='Available Coupons' bold size={fontSize.mediumFontSize} color={appColors.dark} />
                                </View>

                                {orderDiscountList.length > 0 ? orderDiscountList.map((dicountCode, index) => (
                                    <Pressable
                                        onPress={() => {
                                            setOrderDiscountList((prev) => {
                                                const applyDiscount = [...prev]
                                                applyDiscount.forEach((code) => {
                                                    code.selected = (code.id === dicountCode.id)
                                                })
                                                return applyDiscount
                                            })
                                            setTimeout(() => {
                                                scrollToIndex(index)
                                            }, 500)
                                            setCouponCode(dicountCode.promoCode)
                                        }}
                                        key={index}
                                        style={{ borderWidth: 2, borderColor: dicountCode.selected ? appColors.primary : appColors.coolGray, backgroundColor: dicountCode.selected ? appColors.tealPrimary : appColors.light, borderRadius: 12, marginBottom: 12, padding: 16, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.05, shadowRadius: 4, elevation: 2 }}
                                    >
                                        <View style={{ flex: 1 }}>
                                            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 4 }}>
                                                <View style={{ backgroundColor: appColors.primary + '15', paddingHorizontal: 8, paddingVertical: 2, borderRadius: 4, marginRight: 8 }}>
                                                    <ZenText content={dicountCode.promoCode} bold size={fontSize.largerFontSize} color={appColors.primary} />
                                                </View>
                                                <ZenText content={`${Number(dicountCode.discountValue).toFixed(0)}% OFF`} bold color={appColors.mayGreen} size={fontSize.mediumFontSize} />
                                            </View>

                                            {dicountCode.maxAmount && (
                                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                    <ZenText content="Save up to " size={fontSize.smallFontSize} color={appColors.lightFontColor} />
                                                    <ZenText content={`${CommonService.currencyStandard(currencySymbol, String(Number(dicountCode.maxAmount).toFixed(0)))}`} bold color={appColors.dark} size={fontSize.smallFontSize} />
                                                </View>
                                            )}
                                        </View>

                                        <View style={{ width: 32, height: 32, borderRadius: 16, backgroundColor: dicountCode.selected ? appColors.primary : appColors.softSlate, justifyContent: 'center', alignItems: 'center' }}>
                                            <ZenIcon
                                                name={dicountCode.selected ? 'check' : 'tag-outline'}
                                                type='material-community'
                                                size={18}
                                                color={dicountCode.selected ? appColors.light : appColors.disabledGray500}
                                            />
                                        </View>
                                    </Pressable>
                                )) : (
                                    <View style={{ padding: 40, alignItems: 'center' }}>
                                        <ZenIcon name='ticket-percent-outline' type='material-community' size={48} color={appColors.disabledGray500} />
                                        <ZenText content='No applicable coupons found' color={appColors.disabledGray500} style={{ marginTop: 12 }} />
                                    </View>
                                )}
                            </ScrollView>
                        </View>
                    </Popover>


                    {/* viewChanges Screen */}
                    <CustomModal onRequestClose={() => setChangeScreenVisible(false)} visible={changeScreenVisbile} style={{ backgroundColor: appColors.lightBackgroundColor }}>
                        <ViewChangesList visibleScreen={setChangeScreenVisible} products={orderDetails?.orderedProductsList} customizedOrderId={orderDetails?.customizedOrderId ?? ''} />
                    </CustomModal>

                    {/* modifier list open */}
                    <Popover onRequestClose={() => { setModifiersListOpen(false) }} isVisible={modifiersListOpen} popoverStyle={{ borderRadius: 10 }} >
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 15, paddingVertical: 10, backgroundColor: appColors.lightBackgroundColor }}>
                            <ZenText content={'Add modifiers'} bold style={{ textTransform: 'capitalize' }} size={20} />
                            <ZenIcon name='close-circle' type='material-community' size={25} onPress={() => { setModifiersListOpen(false) }} />
                        </View>
                        <View style={{ flex: 1, width: 400, height: 500 }}>
                            <ScrollView >
                                <View>

                                    {
                                        productModifier?.productModifiers ? productModifier?.productModifiers.map((mappings, mapInd: number) =>
                                        (
                                            <View key={mapInd} style={{ paddingHorizontal: 15, marginVertical: 15 }}>
                                                <ZenText content={mappings?.modifierData?.modifierName} bold style={{ textTransform: 'capitalize', }} />
                                                {
                                                    mappings?.modifierData?.modifierSetMappings.map((values, keyInd) =>
                                                    (
                                                        <View key={keyInd} style={{ paddingHorizontal: 15 }}>
                                                            <ZenCheckBox
                                                                onPress={() => {
                                                                    setProductModifiers((prev) => {
                                                                        if (!prev) return prev
                                                                        let addSelected = { ...prev }
                                                                        addSelected.productModifiers.map((selectedModifier) => {
                                                                            if (selectedModifier.id == mappings.id) {
                                                                                selectedModifier?.modifierData?.modifierSetMappings.map((modiferSetData) => {
                                                                                    if (modiferSetData.id == values.id && modiferSetData.isSelected) {
                                                                                        modiferSetData.isSelected = false
                                                                                    }
                                                                                    else if (modiferSetData.id == values.id) {
                                                                                        modiferSetData.isSelected = true
                                                                                    }
                                                                                })
                                                                            }
                                                                        })
                                                                        return addSelected
                                                                    })
                                                                }
                                                                }
                                                                title={values?.modifier?.optionValue}
                                                                checked={values?.isSelected}
                                                                checkedColor={appColors.primary}
                                                                unCheckedColor={appColors.lightDark}
                                                                size={25}
                                                                containerStyle={{ marginVertical: 5, marginHorizontal: 5 }} />
                                                        </View>
                                                    ))
                                                }
                                            </View>
                                        )) : null
                                    }
                                </View>
                            </ScrollView>
                            <View style={{ flexDirection: 'row', backgroundColor: appColors.lightBackgroundColor, justifyContent: 'flex-end', paddingHorizontal: 10, paddingVertical: 10 }}>
                                {isOrderWrite && <ZenButton
                                    title={'update'}
                                    buttonStyle={OrderListStyle.savebutton}
                                    onPress={() => {
                                        setModifiersListOpen(false)
                                        let ModifiersAlreadyExist = [...orderDetails?.orderedProductModifiers ? orderDetails?.orderedProductModifiers.filter((prId) => prId.productId == productModifier?.id) : []]
                                        let filterSelectedSet = productModifier?.productModifiers?.map(
                                            (i) => i.modifierData.modifierSetMappings.filter((value) => value.isSelected) || []
                                        ).flatMap(i => i);
                                        filterSelectedSet = filterSelectedSet ? filterSelectedSet : []
                                        let notExist = false
                                        // Flatten the array safely
                                        if (ModifiersAlreadyExist.length == filterSelectedSet.length) {
                                            for (let findIsExist of filterSelectedSet) {
                                                notExist = false
                                                for (let valueExist of ModifiersAlreadyExist) {
                                                    if (findIsExist.modifierSetId == valueExist.modifierSetId && findIsExist.modifier.id == valueExist.modifierId) {
                                                        notExist = true
                                                    }
                                                }

                                                if (!notExist) {
                                                    notExist = false
                                                    break
                                                }
                                            }
                                        }
                                        if (!notExist) {
                                            handleUpdateProductModifiers()
                                        }
                                        else {
                                            ZenToast({ type: 'info', message: 'The modifier option has already exist' })
                                        }
                                    }}
                                />}
                                <ZenButton
                                    buttonStyle={OrderListStyle.cancelButton}
                                    containerStyle={{ marginHorizontal: 10 }}
                                    titleStyle={{ color: appColors.lightDark }}
                                    title={'cancel'}
                                    onPress={() => {
                                        setModifiersListOpen(false)
                                    }}
                                />
                            </View>
                        </View>

                    </Popover>

                    {/* tracking | shipping details */}
                    <Popover isVisible={trackingVisible}>
                        <View style={{ width: width > 600 ? 500 : width - 30, height: 350, backgroundColor: appColors.lightBackgroundColor, borderRadius: 16, overflow: 'hidden' }}>

                            {/* Header */}
                            <View style={{ flexDirection: 'row', width: '100%', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 16, paddingHorizontal: 20, backgroundColor: appColors.light, borderBottomWidth: 1, borderBottomColor: appColors.coolGray }}>
                                <ZenText content='Tracking Details' bold size={fontSize.headerFontSize} color={appColors.primary} />
                                <ZenIcon type='material' name='close' size={24} color={appColors.dark} onPress={() => { setTrackingVisible(false) }} />
                            </View>

                            <View style={{ padding: 20, flex: 1, justifyContent: 'space-between' }}>
                                <View>
                                    <ZenText
                                        content='Please provide the tracking details for this order.'
                                        size={fontSize.mediumFontSize}
                                        color={appColors.dark}
                                        style={{ marginBottom: 16 }}
                                    />
                                    <ZenInput
                                        value={trackingData}
                                        placeholder='Enter Tracking ID / Details'
                                        containerStyle={{ width: '100%' }}
                                        inputContainerStyle={{ backgroundColor: appColors.light, borderWidth: 1, borderColor: appColors.coolGray, borderRadius: 8, paddingHorizontal: 12, minHeight: 100, alignItems: 'flex-start' }}
                                        multiline
                                        textAlignVertical='top'
                                        onChangeText={(value) => {
                                            setTrackingData(value)
                                        }}
                                    />
                                </View>

                                {isOrderWrite && <ZenButton
                                    title={orderDetails?.trackingId ? 'Update Tracking' : 'Confirm Status'}
                                    disabled={orderDetails?.trackingId ? (String(orderDetails?.trackingId) == trackingData) : !trackingData}
                                    containerStyle={{ width: '100%', height: 48 }}
                                    buttonStyle={{ backgroundColor: appColors.primary, borderRadius: 8 }}
                                    titleStyle={{ fontSize: fontSize.mediumFontSize, fontFamily: appFonts.bold }}
                                    onPress={() => {
                                        if (orderDetails?.trackingId) {
                                            handleUpdateTrackDetails()
                                        }
                                        else {
                                            handleUpdateOrderStatus('order', selectedStatus, true)
                                        }
                                        setTrackingVisible(false)
                                    }}
                                />}
                            </View>
                        </View>
                    </Popover>

                    {/* loyalty | refund screen */}
                    <Popover
                        isVisible={loyaltyVisible || refundVisible}
                        onRequestClose={() => {
                            setLoyaltyVisible(false)
                            setRefundVisible(false)
                            setFullAdjustment(false)
                        }}
                        popoverStyle={{ borderRadius: 20 }}
                    >
                        <View style={{ width: width > 600 ? 500 : width - 50, backgroundColor: appColors.light, borderRadius: 20, overflow: 'hidden' }}>
                            {orderDetails ? <FormTemplate
                                event={refundVisible ? 'Refund' : 'Loyalty'}
                                reasonValue={reasonValue}
                                setReasonValue={setReasonValue}
                                setValue={setFormValue}
                                value={formValue}
                                orderData={orderDetails}
                                handleUpdateRefundAmount={handleUpdateRefundAmount}
                                isValueEnable={fullAdjustment}
                                onClose={() => {
                                    setLoyaltyVisible(false)
                                    setRefundVisible(false)
                                    setFullAdjustment(false)
                                }}
                            /> : null}
                        </View>
                    </Popover>

                    {/* shipping method */}
                    <Popover isVisible={shippingListVisible}>
                        <View style={{ width: width > 600 ? 500 : width - 30, backgroundColor: appColors.lightBackgroundColor, height: height * 0.6, borderRadius: 16, overflow: 'hidden' }}>

                            {/* Header */}
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 16, paddingHorizontal: 20, backgroundColor: appColors.light, borderBottomWidth: 1, borderBottomColor: appColors.coolGray }}>
                                <ZenText content='Edit Shipping Method' bold size={fontSize.headerFontSize} color={appColors.primary} />
                                <ZenIcon name='close' type='material' size={24} color={appColors.dark} onPress={() => {
                                    setShippingListVisible(false)
                                }} />
                            </View>

                            <ScrollView contentContainerStyle={{ padding: 16 }}>
                                <View style={{ width: '100%' }}>
                                    {
                                        shippingList?.updateOrder?.delivery?.map((value, ind: number) =>
                                        (
                                            !value.isExist ? (
                                                <Pressable
                                                    key={ind}
                                                    onPress={() => {
                                                        setShippingList((prev) => {
                                                            if (!prev) return prev
                                                            const addFlag = { ...prev }
                                                            addFlag?.updateOrder?.delivery.forEach((selectedShipping) => {
                                                                selectedShipping.selected = (selectedShipping.id === value.id)
                                                            })
                                                            return addFlag
                                                        })
                                                    }}
                                                    style={{ flexDirection: 'row', alignItems: 'center', padding: 16, backgroundColor: value.selected ? appColors.tealPrimary : appColors.light, borderRadius: 12, borderWidth: 2, borderColor: value.selected ? appColors.primary : appColors.coolGray, marginBottom: 12, shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.05, shadowRadius: 4, elevation: 2 }}
                                                >
                                                    <ZenText
                                                        content={value?.name}
                                                        bold
                                                        size={fontSize.mediumFontSize}
                                                        color={value.selected ? appColors.primary : appColors.dark}
                                                        style={{ textTransform: 'capitalize' }}
                                                    />
                                                </Pressable>
                                            ) : null
                                        ))
                                    }
                                </View>
                            </ScrollView>

                            <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', padding: 16, backgroundColor: appColors.light, borderTopWidth: 1, borderTopColor: appColors.coolGray }}>
                                <ZenButton
                                    title='Cancel'
                                    type='outline'
                                    outlineColor={appColors.primary}
                                    containerStyle={{ height: 44, width: 100, marginRight: 12 }}
                                    buttonStyle={{ borderRadius: 8 }}
                                    titleStyle={{ fontSize: fontSize.mediumFontSize }}
                                    onPress={() => {
                                        setShippingListVisible(false)
                                    }}
                                />
                                {isOrderWrite && <ZenButton
                                    title='Save Changes'
                                    containerStyle={{ height: 44, width: 140 }}
                                    buttonStyle={{ backgroundColor: appColors.primary, borderRadius: 8 }}
                                    titleStyle={{ fontSize: fontSize.mediumFontSize, fontFamily: appFonts.bold }}
                                    onPress={() => {
                                        const deliveryMethods = shippingList?.updateOrder?.delivery || []
                                        const selectedMethod = deliveryMethods.find((v) => v.selected)
                                        if (selectedMethod) {
                                            handleUpdateOrderShipping(selectedMethod)
                                        } else {
                                            ZenToast({ type: 'info', message: 'Please select a shipping method' })
                                        }
                                    }}
                                />}
                            </View>
                        </View>
                    </Popover>

                    {/* Return Request Product/Order */}
                    <CustomModal
                        visible={ReturnRequestScreen}
                        transparent={true}
                        animationType="slide"
                        onRequestClose={() => setReturnRequestScreen(false)}
                        keyboardView
                    >
                        <View style={{ flex: 1, backgroundColor: 'rgba(0, 0, 0, 0.5)', justifyContent: 'center', alignItems: 'center', padding: 20 }}>
                            <View style={{ width: width > 600 ? 500 : '100%', backgroundColor: appColors.light, borderRadius: 16, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.15, shadowRadius: 10, elevation: 5 }}>
                                <ReturnReasonScreen
                                    setReturnRequestScreen={setReturnRequestScreen}
                                    actionData={orderDetails?.returnActionData}
                                    reasonData={orderDetails?.returnReasonData}
                                    isOrder={false}
                                    selectedProduct={selectedProduct}
                                    updateRequest={updateReturnRequest}
                                    width={width}
                                />
                            </View>
                        </View>
                    </CustomModal>

                    {/* {alert Popover for chnaging return request product status} */}
                    <Popover isVisible={returnPopover} mode={PopoverMode.JS_MODAL}>
                        <CommonDialogBox type='OTHER'
                            confirmation={async (args) => {
                                if (args.id == 2) {
                                    if (selectedStockLocation) {
                                        setReturnPopover(false)
                                        updateRestoreStock(enableRestoreStock ? true : false)
                                    }
                                    else {
                                        setReturnPopover(false)
                                        handleUpdateReturnRequestStatus()
                                        await getOrderDetail()
                                    }
                                }
                                else {
                                    setSelectedReturnProduct(null)
                                    setReturnPopover(false)
                                }
                            }
                            }
                            dialog={{ button: [{ id: 1, name: 'no' }, { id: 2, name: 'Yes' }], content: 'Are you sure you want to change the status?' }} />

                    </Popover>

                    {/* restoreLocation fro return products */}
                    <Popover isVisible={restoreLocationVisible}>
                        <View style={{ backgroundColor: appColors.light, width: width > 600 ? 350 : width - 50, height: 250 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 10, backgroundColor: appColors.lightBackgroundColor, paddingVertical: 5, borderRadius: 10 }}>
                                <ZenText content='Restore Location' bold size={fontSize.smallFontSize} color={appColors.lightDark} />
                                <ZenIcon name='close-circle' type='material-community' size={25} onPress={() => { setRestoreLocationVisible(false) }} />

                            </View>
                            <View style={{ flexDirection: 'column', justifyContent: 'space-evenly', }}>
                                <View style={{ marginTop: 20, paddingHorizontal: 15 }}>
                                    <ZenDropdown
                                        items={stockLocation!!}
                                        searchable
                                        open={stockLocationOpen}
                                        setOpen={setStockLocationOpen}
                                        setValue={setSelectedStockLocation}
                                        value={selectedStockLocation}
                                        containerStyle={{ width: '85%', marginVertical: 10 }}
                                        onSelectItem={(value) => {
                                            setSelectedLocationId(value.id)
                                        }
                                        }
                                        dropDownContainerStyle={{ borderColor: '#D9D9D9', borderWidth: 2, height: width >= 600 ? 150 : 150, position: 'relative', top: 0, width: width >= 600 ? 270 : 'auto' }}
                                    />
                                </View>
                                <View style={{ flexDirection: 'row', justifyContent: 'center', paddingHorizontal: 15, paddingVertical: 10, marginTop: 70 }}>
                                    <ZenButton
                                        title='cancel'
                                        titleStyle={{ fontSize: fontSize.smallFontSize }}
                                        type='outline'
                                        buttonStyle={{ borderRadius: 10, padding: 0 }}
                                        outlineColor={appColors.primary}
                                        onPress={() => {
                                            setRestoreLocationVisible(false)
                                        }
                                        }

                                    />
                                    {isOrderWrite && <ZenButton
                                        title='Restore'
                                        disabled={selectedStockLocation ? false : true}
                                        titleStyle={{ fontSize: fontSize.smallFontSize }}
                                        type='solid'
                                        buttonStyle={{ backgroundColor: appColors.primary, borderRadius: 10, marginHorizontal: 10 }}
                                        onPress={() => {
                                            if (enableRestoreStock) {
                                                setAllReturnedStock((prev) => {
                                                    let addAttributes = prev.map((val) => {
                                                        return { ...val, locationId: selectedLocationId };
                                                    });
                                                    return addAttributes;
                                                });
                                            }
                                            setRestoreLocationVisible(false)
                                            enableRestorePopover()
                                        }
                                        }
                                    />}
                                </View>
                            </View>

                        </View>

                    </Popover>

                    <Popover isVisible={returnProductDetailsPopOver}>
                        <View >
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 10, paddingVertical: 5, backgroundColor: appColors.lightBackgroundColor }}>
                                <ZenText content='ReturnProductDetails' bold size={fontSize.smallFontSize} />
                                <ZenIcon name='close-circle' type='material-community' size={25} onPress={() => {
                                    setReturnProductDetailsPopOver(false)
                                }
                                } />
                            </View>
                            <View style={{ paddingHorizontal: 10 }}>
                                {selectedReturnProduct ?
                                    <>
                                        <TextTemplate amount={selectedReturnProduct?.returnRequestsProductData?.name} name='Product Name' />
                                        <TextTemplate amount={selectedReturnProduct?.returnQty} name='Return Quantity' />
                                        <TextTemplate amount={selectedReturnProduct?.status} name='Return Status' />
                                        <TextTemplate amount={selectedReturnProduct?.action} name='Return Action' />
                                        <TextTemplate amount={selectedReturnProduct?.reason} name='Return Reason' />
                                        <TextTemplate amount={selectedReturnProduct?.comments} name='Return Comment' />
                                        <TextTemplate amount={moment(new Date(selectedReturnProduct?.modifiedAt)).format('DD/MM/YYYY')} name='Date ' />
                                    </> : null
                                }
                                {/* <TextTemplate amount={selectedReturnProduct?.orderAmount} name='Restored Location' /> */}
                            </View>

                        </View>
                    </Popover>

                    <CustomModal
                        visible={sendReceiptModalVisible}
                        transparent={true}
                        animationType="slide"
                        onRequestClose={() => setSendReceiptModalVisible(false)}
                        keyboardView
                    >
                        <View style={{ flex: 1, backgroundColor: 'rgba(0, 0, 0, 0.5)', justifyContent: 'center', alignItems: 'center', padding: 20 }}>
                            <View style={{ width: width > 600 ? 500 : '100%', backgroundColor: appColors.light, borderRadius: 16, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.15, shadowRadius: 10, elevation: 5 }}>
                                {/* Modal Header */}
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderBottomWidth: 1, borderBottomColor: appColors.coolGray, paddingBottom: 15, marginBottom: 20 }}>
                                    <ZenText content="Send Receipt" bold size={fontSize.headerFontSize} color={appColors.primary} />
                                    <ZenIcon name="close" type="material-community" size={24} color={appColors.dark} onPress={() => setSendReceiptModalVisible(false)} />
                                </View>

                                {/* Modal Body */}
                                <ScrollView showsVerticalScrollIndicator={false} style={{ maxHeight: height * 0.7 }} nestedScrollEnabled={true}>
                                    {/* Email Receipt Option */}
                                    <View style={{ marginBottom: 20, borderWidth: 1, borderColor: appColors.coolGray, padding: 15, borderRadius: 12 }}>
                                        <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                                            <ZenIcon name="email-outline" type="material-community" size={20} color={appColors.primary} style={{ marginRight: 8 }} />
                                            <ZenText content="Email Receipt" bold size={fontSize.mediumFontSize} color={appColors.dark} />
                                        </View>
                                        <ZenInput
                                            value={receiptEmail}
                                            onChangeText={(text) => {
                                                setReceiptEmail(text);
                                                if (emailError) setEmailError('');
                                            }}
                                            placeholder="Enter customer email address..."
                                            containerStyle={{ height: 45, marginBottom: 5 }}
                                            inputContainerStyle={{ borderRadius: 8, borderWidth: 1, borderColor: emailError ? appColors.red : appColors.coolGray, paddingHorizontal: 10 }}
                                        />
                                        {!!emailError && (
                                            <ZenText content={emailError} size={fontSize.smallerFontSize} color={appColors.red} style={{ marginBottom: 10, marginLeft: 5 }} />
                                        )}
                                        <ZenButton
                                            title="Send Email"
                                            onPress={handleSendEmail}
                                            buttonStyle={{ backgroundColor: appColors.primary, borderRadius: 8, height: 40 }}
                                            titleStyle={{ fontSize: fontSize.smallFontSize }}
                                        />
                                    </View>

                                    {/* Text Receipt Option */}
                                    <View style={{ marginBottom: 20, borderWidth: 1, borderColor: appColors.coolGray, padding: 15, borderRadius: 12 }}>
                                        <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                                            <ZenIcon name="phone-outline" type="material-community" size={20} color={appColors.primary} style={{ marginRight: 8 }} />
                                            <ZenText content="Text Receipt (SMS)" bold size={fontSize.mediumFontSize} color={appColors.dark} />
                                        </View>
                                        <ZenInput
                                            value={receiptPhone}
                                            onChangeText={(text) => {
                                                setReceiptPhone(text);
                                                if (phoneError) setPhoneError('');
                                            }}
                                            placeholder="Enter customer phone number..."
                                            containerStyle={{ height: 45, marginBottom: 5 }}
                                            inputContainerStyle={{ borderRadius: 8, borderWidth: 1, borderColor: phoneError ? appColors.red : appColors.coolGray, paddingHorizontal: 10 }}
                                        />
                                        {!!phoneError && (
                                            <ZenText content={phoneError} size={fontSize.smallerFontSize} color={appColors.red} style={{ marginBottom: 10, marginLeft: 5 }} />
                                        )}
                                        <ZenButton
                                            title="Send Text"
                                            onPress={handleSendSMS}
                                            buttonStyle={{ backgroundColor: appColors.primary, borderRadius: 8, height: 40 }}
                                            titleStyle={{ fontSize: fontSize.smallFontSize }}
                                        />
                                    </View>

                                    {/* Gift Receipt Option */}
                                    <View style={{ borderWidth: 1, borderColor: appColors.coolGray, padding: 15, borderRadius: 12, marginBottom: 15 }}>
                                        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 15 }}>
                                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                <ZenIcon name="gift-outline" type="material-community" size={20} color={appColors.primary} style={{ marginRight: 8 }} />
                                                <ZenText content="Gift Receipt" bold size={fontSize.mediumFontSize} color={appColors.dark} />
                                            </View>
                                            <ZenCheckBox
                                                checked={isGiftReceipt}
                                                onPress={() => setIsGiftReceipt(!isGiftReceipt)}
                                                checkedColor={appColors.primary}
                                                containerStyle={{ margin: 0, padding: 0 }}
                                            />
                                        </View>
                                        {isGiftReceipt && (
                                            <ZenButton
                                                title="Print Gift Receipt"
                                                type="outline"
                                                outlineColor={appColors.primary}
                                                onPress={handlePrintGiftReceipt}
                                                buttonStyle={{ borderRadius: 8, height: 40 }}
                                                titleStyle={{ fontSize: fontSize.smallFontSize, color: appColors.primary }}
                                            />
                                        )}
                                    </View>
                                </ScrollView>

                                {/* Cancel Button */}
                                <ZenButton
                                    title="Cancel"
                                    type="clear"
                                    onPress={() => setSendReceiptModalVisible(false)}
                                    titleStyle={{ color: appColors.lightDark, fontSize: fontSize.mediumFontSize }}
                                    containerStyle={{ marginTop: 10 }}
                                />
                            </View>
                        </View>
                    </CustomModal>

                </KeyboardAvoidingView >
            )
            }
        </ThemeConsumer >
    )

}
export default OrderDetails;
